import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react'
import TextEditor from '../../../../../../../../shared-components/TextEditor';
// import { format } from 'date-fns';
// import { IconAddPlus, IconPlusBg } from '../../../../../../../shared/IconsComponent/icons';
import { useSelector } from 'react-redux';
import AddNewProblem from '../../../EncounterLeftPortion/Components/Tabs/Summary/Components/Problems/AddNewProblem';
import { Modal, ModalBody } from "react-bootstrap";
// import ModalHeader from '../../../../../../../Setup/Shared/ModalHeader';
import AddNewDocument from '../Components/AddNewDocument';
import DropdownValueHandler from '../../../../../../../shared/SuperSearch/DropdownValueHandler';
import { enumUtil } from '../../../../../../../../utils/Enum';
import { ServerRequestProtected, ServerRequestPublic } from '../../../../../../../../utils/ServerDataRequest';
import Loader from '../../../../../../../shared/Loader/Loader';
import SuperICDandCPTSearch from '../../../../../../../shared/SuperSearch/ICDAndCPTSelection/SuperICDandCPTSearch';
import isNull from '../../../../../../../../utils/NullChecking';
import AddNewDiagnosis from '../../../../../../../Setup/Coding/DiagnosisCode/AddNewDiagnosis';
import EncounterPreview from './Components/EncounterPreview';
import PrintOutSelectDataModal from './Components/PrintOutSelectDataModal';
import useCaptureDataAndGeneratePDFBrowserAPI from '../../../../../../../shared/CaptureDataAndGeneratePDF/useCaptureDataAndGeneratePDFBrowserAPI';
import SignEncounter from '../Components/SignEncounter';
import handleNumericCheck from '../../../../../../../../utils/HandleNumericKeys';
import _ from 'lodash';
import AddNewProcedureCodes from '../../../../../../../Setup/Coding/ProcedureCode/AddNewProcedureCodes';
import ContentReceiver from '../../../../../../../MenuLayout/ContentReceiverNewBrowserTab/ContentReceiver';
import { FindFirstChild, FindSecondChild } from '../../../../../../../../utils/FindMenuOption';
import useClaimLinkingEncounter from '../Components/useClaimLinkingEncounter';
import SelectedPreviewDataV2 from './Components/SelectedPreviewDataV2';
import DatePicker from '../../../../../../../General/DatePicker';
import FormatDate from '../../../../../../../shared/DateFormatter';
import RangeOfMotion from './Components/ObjectiveSections/RangeOfMotion';
import Strength from './Components/ObjectiveSections/Strength';
import SuperSearchList from '../../../../../../../shared/SuperSearch/SuperSearchList';
import ProblemArea from './Components/ObjectiveSections/ProblemArea';
import CustomTemplateForm from '../Components/Custom Template Form/CustomTemplateForm';

const PhysicalNote = forwardRef(({
    initialData,
    saveSignal,
    setAccordions,
    searchParam,
    setSearchParam,
    showPreview,
    searchValue,
    setSaveQualityOfCareData,
    onSave,
    encounterID,
    ...props }, ref) => {


    console.log("patientIDPhysicalNote", props?.patientID)
    // {
    //     "QualityOfCareID" :"",
    //     "SummaryOfCareSent" : "false",
    //     "IncomingTransferOfPatient" : "false",
    //     "OutgoingTransferOfCare" : "false",
    //     "EducationMaterialGiven" : "true",
    //     "PatientDeclinedSummary" : "false",
    //     "VirtualVisit" : "true"
    // }
    let { printoutSelectDataModal,
        setPrintoutSelectDataModal,
        printoutModal,
        setPrintoutModal,
        isProcedureEdit,
        setIsProcedureEdit,
        patientID = null,
        mainServiceLineModal,
        setMainServiceLineModal,
        // selectedItems,
        // setSelectedItems ,
        defaultSelectedItems,
        selectedItems,
        setSelectedItems,
    } = props;

    let isClaimViewAllowed = FindSecondChild('Billing', 'Claims', 'Claims')?.ISView
    let isSuperbillEditAllowed = FindFirstChild('Patient', 'Add SuperBill')?.IsAdd;
    let isCreateClaimEditAllowed = FindFirstChild('Patient', 'Create Claim For SuperBill')?.IsAdd;
    let isSignEditAllowed = FindFirstChild('Patient', 'Sign Encounters')?.IsAdd;
    let IsEditAllowed = FindFirstChild('Patient', 'Encounter')?.IsAdd ?? true;
    let IsDeleteAllowed = FindFirstChild('Patient', 'Encounter')?.IsDeleted ?? true;

    // const [cptBody, setcptBody] = useState({ "TableName": enumUtil.enumAPITableName.Procedure, "SearchParam": '' })
    const [openTab, setOpenTab] = useState('')
    const [isSign, setIsSign] = useState(false);
    // const quillHistoryofPresentIllnessNotesRef = useRef(null);
    // const quillReviewOfSystemNotesRef = useRef(null);
    const quillSubjectiveNotesRef = useRef(null);
    // const quillHPIRef = useRef(null);
    // const quillROSRef = useRef(null);
    const imageRef = useRef(null);
    const quillObservationNotesRef = useRef(null);
    const quillPalpationNotesRef = useRef(null);
    const quillTestMeasurementsNotesRef = useRef(null);
    const quillObjectiveNotesRef = useRef(null);
    // const quillFocusAreaRef = useRef(null);
    const quillAssessmentRef = useRef(null);
    // const quillPrescriptionsRef = useRef(null);
    // const quillSupplementsRef = useRef(null);
    // const quillVaccinesRef = useRef(null);
    // const quillInjectionsRef = useRef(null);
    // const quillLabsRef = useRef(null);
    // const quillImagingRef = useRef(null);
    const quillPlanRef = useRef(null);
    const quillHEPRef = useRef(null);
    const quillFollowUpRef = useRef(null);
    const quillAdditionalInfoRef = useRef(null);
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    let RecentCPTs = useSelector(state => state.CodesDropDownReducer.RecentCPT)
    console.log("initialDatainitialData", initialData)
    const [isLoading, setIsLoading] = useState(false)
    const [isCollapsed, setIsCollapsed] = useState(false);
    const handleCollapseClick = () => {
        setIsCollapsed(!isCollapsed); // Toggle the collapse state
    };
    const [selectedDiagnosisValue, setSelectedDiagnosisValue] = useState('')
    const [icdBody, setIcdBody] = useState({ "TableName": enumUtil.enumAPITableName.Diagnosis, "SearchParam": '' })
    let { divClaimLinking, LoadDD, dataExist } = useClaimLinkingEncounter(patientID, encounterID, props?.setReloadAfterSave);

    let Problems_Modal = {
        ProblemName: "",
        // OnSetDate: "",
        // ImplantableDeviceStatus: "",
    }
    const [showInActiveProblems, setShowInActiveProblems] = useState(false);
    // const [problemsSaveUpdateModal, setProblemsSaveUpdateModal] = useState([])
    const [mainProblemsModal, setMainProblemsModal] = useState(Problems_Modal);

    const [activeAccord, setActiveAccord] = useState({ 'SUBJECTIVE': true, 'OBJECTIVE': true, 'ASSESSMENT': true, 'PLAN': true, 'AdditionalINFO': true, });
    const [itemsCollapsed, setItemsCollapsed] = useState({});

    let SUBJECTIVE_MODEL = {
        "ChiefComplaint": initialData?.Data?.ChiefComplaint || "",
        // "HistoryofPresentIllnessNotes": initialData?.Data?.HistoryofPresentIllnessNotes || "",
        // "HistoryOfPresentIllness": initialData?.HistoryOfPresentIllness || {},
        // "ReviewOfSystemNotes": initialData?.Data?.ReviewOfSystemNotes || "",
        // "ReviewOfSystem": initialData?.ReviewOfSystem || {},
        "SubjectiveNotes": initialData?.Data?.SubjectiveNotes || "",
    }
    const [subjectiveData, setSubjectiveData] = useState(SUBJECTIVE_MODEL);

    let OBJECTIVE_MODEL = {
        // "ObjectiveFinding": initialData?.ObjectiveFinding || {},
        "FrontBodyDiagram": initialData?.FrontBodyDiagram || [],
        "BackBodyDiagram": initialData?.BackBodyDiagram || [],
        "ObservationNotes": initialData?.Data?.ObservationNotes || "",
        "PalpationNotes": initialData?.Data?.PalpationNotes || "",
        "RangeOfMotion": initialData?.RangeOfMotion || {},
        "Strength": initialData?.Strength || {},
        // "ObjectiveNotes": initialData?.Data?.ObjectiveNotes || "",
        "TestMeasurementNotes": initialData?.Data?.TestMeasurementNotes || "",
        "ObjectiveNotes": initialData?.Data?.ObjectiveNotes || "",
        // "Vital": initialData?.Vital || [],
    }
    const [objectiveData, setObjectiveData] = useState(OBJECTIVE_MODEL);

    let OBSERVATIONS_MODEL = {
        // "CognitiveStatus": initialData?.CognitiveStatus || [],
        // "FunctionalStatus": initialData?.FunctionalStatus || [],
    }
    const [observationsData, setObservationsData] = useState(OBSERVATIONS_MODEL);

    let ASSESSMENT_MODEL = {
        // "AssessmentAreaTreated": initialData?.AssessmentAreaTreated || {},
        // "AssessmentMethodUsed": initialData?.AssessmentMethodUsed || {},
        "AssesmentNotes": initialData?.Data?.AssesmentNotes || "",
        "EncounterProblem": initialData?.EncounterProblem || [],
    }
    const [assessmentData, setAssessmentData] = useState(ASSESSMENT_MODEL);

    let PLAN_MODEL = {
        // "PrescriptionsNotes": initialData?.Data?.PrescriptionsNotes || "",
        // "SupplementsNotes": initialData?.Data?.SupplementsNotes || "",
        // "VaccinesNotes": initialData?.Data?.VaccinesNotes || "",
        // "InjectionsNotes": initialData?.Data?.InjectionsNotes || "",
        // "LabsNotes": initialData?.Data?.LabsNotes || "",
        // "ImagingNotes": initialData?.Data?.ImagingNotes || "",
        "PlanNotes": initialData?.Data?.PlanNotes || "",
        // "TestMeasurementNotes": initialData?.Data?.TestMeasurementNotes || "",
        "HomeExerciseProgram": initialData?.Data?.HomeExerciseProgram || "",
        "FollowUpDate": !isNull(initialData?.Data?.FollowUpDate) ? FormatDate(initialData?.Data?.FollowUpDate) : "",
        "FollowUpNotes": initialData?.Data?.FollowUpNotes || "",
        // "Vital": initialData?.Vital || [],
    }
    const [planData, setPlanData] = useState(PLAN_MODEL);
    // const [addVital, setAddVital] = useState(false);
    const API_URL = enumUtil.controller.Claim;

    const API_URL_GENERAL = enumUtil.controller.General;
    // PatientEncounter

    let RecentICDs = useSelector(state => state.CodesDropDownReducer.RecentICD)
    let RecentModifiers = useSelector(state => state.CodesDropDownReducer.RecentModifier)

    const [PatDxData, setPatDxData] = useState([])

    // let PatientIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true))?.data?.id;

    // const [vitalData, setVitalData] = useState([{
    //     PatientID: patientID,
    //     VitalID: "0",
    //     VitalName: "Height",
    //     VitalValue: ""
    // }, {
    //     PatientID: patientID,
    //     VitalID: "0",
    //     VitalName: "Weight",
    //     VitalValue: ""
    // }, {
    //     PatientID: patientID,
    //     VitalID: "0",
    //     VitalName: "BMI",
    //     VitalValue: ""
    // }, {
    //     PatientID: patientID,
    //     VitalID: "0",
    //     VitalName: "BMI Percentile",
    //     VitalValue: ""
    // }, {
    //     PatientID: patientID,
    //     VitalID: "0",
    //     VitalName: "BP",
    //     VitalValue: ""
    // }, {
    //     PatientID: patientID,
    //     VitalID: "0",
    //     VitalName: "Temperature",
    //     VitalValue: ""
    // }, {
    //     PatientID: patientID,
    //     VitalID: "0",
    //     VitalName: "Pulse",
    //     VitalValue: ""
    // }, {
    //     PatientID: patientID,
    //     VitalID: "0",
    //     VitalName: "Respiratory Rate",
    //     VitalValue: ""
    // }, {
    //     PatientID: patientID,
    //     VitalID: "0",
    //     VitalName: "O2 Saturation",
    //     VitalValue: ""
    // }, {
    //     PatientID: patientID,
    //     VitalID: "0",
    //     VitalName: "Pain",
    //     VitalValue: ""
    // }, {
    //     PatientID: patientID,
    //     VitalID: "0",
    //     VitalName: "Head Circumference",
    //     VitalValue: ""
    // }]);

    let vitalKeysList = [
        "Height",
        "Weight",
        "BMI",
        "BMI Percentile",
        "BP",
        "Temperature",
        "Pulse",
        "Respiratory Rate",
        "O2 Saturation",
        "Pain",
        "Head Circumference"
    ];

    // let vitalUnitList = [
    //     "in",
    //     "lb",
    //     "",
    //     "%",
    //     "",
    //     "",
    //     "",
    //     "",
    //     "%",
    //     "",
    //     "cm"
    // ];


    // US Customary Units
    let vitalUnitListUSList = [
        "in",   // Height
        "lb",   // Weight
        "",     // BMI
        "%",    // BMI Percentile
        "mmHg", // BP
        "°F",   // Temperature
        "bpm",  // Pulse
        "breaths/min", // Respiratory Rate
        "%",    // O2 Saturation
        "",     // Pain
        "in"    // Head Circumference
    ];

    // Metric Units
    let vitalUnitListMetricList = [
        "cm",   // Height
        "kg",   // Weight
        "",     // BMI
        "%",    // BMI Percentile
        "mmHg", // BP
        "°C",   // Temperature
        "bpm",  // Pulse
        "breaths/min", // Respiratory Rate
        "%",    // O2 Saturation
        "",     // Pain
        "cm"    // Head Circumference
    ];

    const vitalUnitList = useMemo(() => {
        if (searchParam?.VitalUnitType === "US Customary") {
            return vitalUnitListUSList;
        } else if (searchParam?.VitalUnitType === "Metric") {
            return vitalUnitListMetricList;
        }
    }, [searchParam?.VitalUnitType]);

    const handleGetUnits = (VitalUnitType) => {
        if (VitalUnitType === "US Customary") {
            return vitalUnitListUSList;
        } else if (VitalUnitType === "Metric") {
            return vitalUnitListMetricList;
        }
    }

    let AdditionalINFO_MODEL = {
        "AdditionalInfoNotes": initialData?.Data?.AdditionalInfoNotes || "",
        "EncounterDocument": initialData?.EncounterDocument || [],
    }

    const API_URL_PATIENTENCOUNTER = enumUtil.controller.PatientEncounter
    const [vitalsPastData, setVitalsPastData] = useState({});
    const [is, setIs] = useState(false);
    const [additionalInfoData, setAdditionalInfoData] = useState(AdditionalINFO_MODEL);

    let QUALITY_OF_CARE_MODEL = {
        ...initialData?.QualityOfCare
    }
    const [qualityOfCareData, setQualityOfCareData] = useState(QUALITY_OF_CARE_MODEL);
    console.log("initialDataSUPER_BILL_MODEL", initialData)
    let SUPER_BILL_MODEL = [
        // ...initialData?.SuperBill
    ]
    const [superBillData, setSuperBillData] = useState(SUPER_BILL_MODEL);
    /////// Problems ////////
    const [isOpenProblems, setIsOpenProblems] = useState(false);
    const [problemsID, setProblemsID] = useState();
    const [problemModal, setProblemModal] = useState({});
    const [saveProblemsData, setSaveProblemsData] = useState([]);
    /////// Documents ////////
    const [isOpenDocument, setIsOpenDocument] = useState(false);
    const [documentID, setDocumentID] = useState();
    const [documentModal, setDocumentModal] = useState({});
    const [saveDocumentData, setSaveDocumentData] = useState([]);
    /////// Objective Finding ////////
    // const [saveObjectiveFindingData, setSaveObjectiveFindingData] = useState({
    //     "ObjectiveFindingID": "",
    //     ...initialData?.ObjectiveFinding
    // });

    /////// Front Body Diagram ////////
    // {
    //     "FrontBodyDiagramID": "",
    //     ...initialData?.FrontBodyDiagram
    // }
    const [saveFrontBodyDiagramData, setSaveFrontBodyDiagramData] = useState([]);
    /////// Back Body Diagram ////////
    // {
    //     "BackBodyDiagramID": "",
    //     ...initialData?.BackBodyDiagram
    // }
    const [saveBackBodyDiagramData, setSaveBackBodyDiagramData] = useState([]);
    /////// Range Of Motion ////////
    const [saveRangeOfMotionData, setSaveRangeOfMotionData] = useState({
        "PT_ROM_RangeOfMotionID": "",
        ...initialData?.RangeOfMotion
    });
    /////// Strength ////////
    const [saveStrengthData, setSaveStrengthData] = useState({
        "PT_Str_StrengthID": "",
        ...initialData?.Strength
    });
    /////// Assessment Area Treated ////////
    // const [saveAssessmentAreaTreatedData, setSaveAssessmentAreaTreatedData] = useState({
    //     "AssessmentAreaTreatedID": "",
    //     ...initialData?.AssessmentAreaTreated
    // });
    /////// Assessment Method Used ////////
    // const [saveAssessmentMethodUsedData, setSaveAssessmentMethodUsedData] = useState({
    //     "AssessmentMethodUsedID": "",
    //     ...initialData?.AssessmentMethodUsed
    // });
    // /////// Review of System ////////
    // const [saveROSData, setSaveROSData] = useState({
    //     "ReviewOfSystemID": "",
    //     ...initialData?.ReviewOfSystem
    // });
    // /////// Objective ////////
    // const [saveHPIData, setSaveHPIData] = useState({
    //     "HistoryOfPresentIllnessID": "",
    //     ...initialData?.HistoryOfPresentIllness
    // });
    /////// Observations ////////
    // const [saveCognitiveStatusData, setSaveCognitiveStatusData] = useState([]);
    // const [saveFunctionalStatusData, setSaveFunctionalStatusData] = useState([]);
    /////////////////////////
    const [pastVitalsLoaded, setPastVitalsLoaded] = useState(false);

    const handleAccordionChange = (key) => {
        setAccordions(prev => prev.map(accord => accord.key === key ? { ...accord, active: !accord.active } : { ...accord }));
        handleAccord(key);
    }

    const handleHoveredItem = (id) => {
        if (!pastVitalsLoaded && id === "ref-OBJECTIVE-Vitals") return;
        props?.setHoveredItem(id);
    }

    const handleActiveItem = (id) => {
        props?.setActiveID(id);

        const elementBar = document.getElementById(`vertical-bar-${id}`);
        if (elementBar) {
            elementBar.scrollIntoView({ behavior: 'smooth' });
        }
    }

    const handleAccord = (name) => {
        setActiveAccord(prev => ({ ...prev, [name]: !prev[name] }))
    }

    const handleItemsExpanded = (name) => {
        setItemsCollapsed(prev => ({ ...prev, [name]: !prev[name] }))
    }

    const handleChange = (e, type) => {
        let { name, value } = e.target;

        if (type === 'Subjective') {
            setSubjectiveData(prev => ({
                ...prev, [name]: value,
            }));
        }
        if (type === 'Plan') {
            setPlanData(prev => ({
                ...prev, [name]: value,
            }));
        }

    }

    // const handleChangeVitalData = (e) => {
    //     let { name, value } = e.target;
    //     setVitalData(prev =>
    //         prev.map(row => {
    //             if (row.VitalName === name) {
    //                 return {
    //                     ...row,
    //                     VitalValue: value,
    //                 }
    //             }
    //             return row;
    //         }))
    // }

    const handleChangeFreeText = (value, type) => {

        if (type === 'HistoryofPresentIllnessNotes') {
            setSubjectiveData(prev => ({
                ...prev, "HistoryofPresentIllnessNotes": value,
            }));
        }
        if (type === 'ReviewOfSystemNotes') {
            setSubjectiveData(prev => ({
                ...prev, "ReviewOfSystemNotes": value,
            }));
        }
        if (type === 'Subjective') {
            setSubjectiveData(prev => ({
                ...prev, "SubjectiveNotes": value,
            }));
        }

        if (type === 'Objective') {
            setObjectiveData(prev => ({
                ...prev, "ObjectiveNotes": value,
            }));
        }
        if (type === 'Observations') {
            setObjectiveData(prev => ({
                ...prev, "ObservationNotes": value,
            }));
        }
        if (type === 'Palpation') {
            setObjectiveData(prev => ({
                ...prev, "PalpationNotes": value,
            }));
        }
        if (type === 'TestMeasurementNotes') {
            setObjectiveData(prev => ({
                ...prev, "TestMeasurementNotes": value,
            }));
        }

        // if (type === 'FocusArea') {
        //     setAssessmentData(prev => {
        //         return ({
        //             ...prev,
        //             'AssessmentAreaTreated': { ...prev?.AssessmentAreaTreated, 'AAT_FocusArea': value },
        //         });
        //     });

        //     setSaveAssessmentAreaTreatedData(prev => ({
        //         ...prev,
        //         'AAT_FocusArea': value
        //     }));
        // }

        if (type === 'Assessment') {
            setAssessmentData(prev => ({
                ...prev, "AssesmentNotes": value,
            }));
        }

        // Plan
        if (type === 'PrescriptionsNotes') {
            setPlanData(prev => ({
                ...prev, "PrescriptionsNotes": value,
            }));
        }
        if (type === 'SupplementsNotes') {
            setPlanData(prev => ({
                ...prev, "SupplementsNotes": value,
            }));
        }
        if (type === 'VaccinesNotes') {
            setPlanData(prev => ({
                ...prev, "VaccinesNotes": value,
            }));
        }
        if (type === 'InjectionsNotes') {
            setPlanData(prev => ({
                ...prev, "InjectionsNotes": value,
            }));
        }
        if (type === 'LabsNotes') {
            setPlanData(prev => ({
                ...prev, "LabsNotes": value,
            }));
        }
        if (type === 'ImagingNotes') {
            setPlanData(prev => ({
                ...prev, "ImagingNotes": value,
            }));
        }
        if (type === 'Plan') {
            setPlanData(prev => ({
                ...prev, "PlanNotes": value,
            }));
        }
        if (type === 'HomeExerciseProgram') {
            setPlanData(prev => ({
                ...prev, "HomeExerciseProgram": value,
            }));
        }
        if (type === 'FollowUpNotes') {
            setPlanData(prev => ({
                ...prev, "FollowUpNotes": value,
            }));
        }

        if (type === 'AdditionalInfo') {
            setAdditionalInfoData(prev => ({
                ...prev, "AdditionalInfoNotes": value,
            }));
        }
    }
    ////////////// setMainServiceLineModal //////////////////
    useEffect(() => {
        setMainServiceLineModal(initialData?.SuperBill);
    }, []);
    /// Update PatDxData if Problem Added in Save Modal ///
    useEffect(() => {
        if (!isOpenProblems && saveProblemsData?.length > 0) {
            setPatDxData(prev => {
                const existingIDs = prev.map(item => item.DiagnosisCodeID);
                const newItems = saveProblemsData.filter(
                    item => !existingIDs.includes(item.DiagnosisCodeID)
                ).map(it => ({
                    ...it,
                    display: it.DiagnosisCode,
                    value: it.DiagnosisCodeID
                }));
                return [...prev, ...newItems];
            });
        }
    }, [isOpenProblems])

    const getStructerdSaveData = () => {
        let { Data, ...restObj } = { ...initialData };
        let { UpdateDate, UpdatedBy, TableName, ...data } = { ...Data };
        let { HistoryOfPresentIllness, ReviewOfSystem, ...saveSubjectiveData } = subjectiveData;
        Data = {
            ...data,
            ...searchParam,
            ...(saveSubjectiveData || {}),
            "ObservationNotes": objectiveData?.ObservationNotes,
            "PalpationNotes": objectiveData?.PalpationNotes,
            "TestMeasurementNotes": objectiveData?.TestMeasurementNotes,
            "ObjectiveNotes": objectiveData?.ObjectiveNotes,
            "AssesmentNotes": assessmentData?.AssesmentNotes,
            // "PrescriptionsNotes": planData?.PrescriptionsNotes || "",
            // "SupplementsNotes": planData?.SupplementsNotes || "",
            // "VaccinesNotes": planData?.VaccinesNotes || "",
            // "InjectionsNotes": planData?.InjectionsNotes || "",
            // "LabsNotes": planData?.LabsNotes || "",
            // "ImagingNotes": planData?.ImagingNotes || "",
            "PlanNotes": planData?.PlanNotes,
            "HomeExerciseProgram": planData?.HomeExerciseProgram,
            "FollowUpDate": planData?.FollowUpDate || "",
            "FollowUpNotes": planData?.FollowUpNotes || "",

            "AdditionalInfoNotes": additionalInfoData?.AdditionalInfoNotes,
        };
        // let vitalValExist = vitalData.some(key => !isNull(key.VitalValue));
        // let { TableName: TableNameHPI, ...hpiDataSave } = saveHPIData;
        // let { TableName: TableNameROS, ...rosDataSave } = saveROSData;
        // let { TableName: TableNameObjectiveFinding, EncounterID: EncounterIDObjectiveFinding = "", ...objectiveFindingDataSave } = saveObjectiveFindingData;

        // let { TableName: TableNameFrontBodyDiagramData, EncounterID: EncounterIDFrontBodyDiagramData = "", ...frontBodyDiagramDataSave } = saveFrontBodyDiagramData;
        // let { TableName: TableNameBackBodyDiagramData, EncounterID: EncounterIDBackBodyDiagramData = "", ...backBodyDiagramDataSave } = saveBackBodyDiagramData;
        let { TableName: TableNameRangeOfMotionData, EncounterID: EncounterIDRangeOfMotionData = "", ...rangeOfMotionDataSave } = saveRangeOfMotionData;
        let { TableName: TableNameStrengthData, EncounterID: EncounterIDStrengthData = "", ...strengthDataSave } = saveStrengthData;
        // let { TableName: TableNameAssessmentMethodUsed, EncounterID: EncounterIDAssessmentMethodUsed = "", ...assessmentMethodUsedDataSave } = saveAssessmentMethodUsedData;
        // let { TableName: TableNameAssessmentAreaTreated, EncounterID: EncounterIDAssessmentAreaTreated = "", ...assessmentAreaTreatedDataSave } = saveAssessmentAreaTreatedData;

        // console.log("rosDataSave", rosDataSave)
        restObj = {
            ...restObj,
            "EncounterCoSign": props?.saveEncounterCoSignData,
            "CustomTemplate": props?.saveCustomTemplateData,
            // "Vital": saveModal?.OBJECTIVE?.Vital,
            // "EncounterProblem": saveModal?.ASSESSMENT?.EncounterProblem,
            // "Vital": vitalValExist ? vitalData : [],


            "EncounterProblem": saveProblemsData,
            "EncounterDocument": saveDocumentData,
            "EncounterAddendum": props?.saveAddendumData,
            "QualityOfCare": props?.saveQualityOfCareData,
            "SuperBill": mainServiceLineModalSaveData,
            "RangeOfMotion": rangeOfMotionDataSave,
            "Strength": strengthDataSave,
            "FrontBodyDiagram": saveFrontBodyDiagramData,
            "BackBodyDiagram": saveBackBodyDiagramData


            // "ObjectiveFinding": objectiveFindingDataSave,
            // "AssessmentMethodUsed": assessmentMethodUsedDataSave,
            // "AssessmentAreaTreated": assessmentAreaTreatedDataSave,
            // "CognitiveStatus": saveCognitiveStatusData,
            // "FunctionalStatus": saveFunctionalStatusData,
            // "HistoryOfPresentIllness": hpiDataSave,
            // "ReviewOfSystem": rosDataSave
            // saveHPIData
            // saveROSData
        }

        // setAddVital(false);
        return { ...restObj, Data };
    }

    useEffect(() => {
        if (saveSignal) {
            let saveData = getStructerdSaveData();
            onSave('Physical', saveData);
        }
    }, [saveSignal]);

    // const getVitalKeys = () => {
    //     let keys = []
    //     initialData.Vital.map(encounter => (
    //         encounter.Vital.map(vital => (
    //             !keys.includes(vital.VitalName) && keys.push(vital.VitalName)
    //         ))
    //     ))
    //     return keys
    // }
    // let vitalKeys = getVitalKeys();

    const handleAddVital = () => {
        // setVitalData(prev => ({
        //     ...prev, 
        //     // Date: format(new Date, 'MM/dd/yyy'), 
        //     // Time: format(new Date(), 'hh:mm a')
        // }));
        // setVitalData()   
        // setAddVital(true);
    }


    const AddDocument = (doc) => {
        setDocumentID(doc.PatientDocumentID || "0");
        setDocumentModal(doc);
        setIsOpenDocument(prev => !prev);
    }
    const CloseDocument = () => {
        setIsOpenDocument(false)
    }
    let PopupScreenDocument = "";
    if (isOpenDocument) {
        PopupScreenDocument = <AddNewDocument isOpenDocument={isOpenDocument} PatientDocumentID={documentID} documentModal={documentModal} setDocumentModal={setDocumentModal} onClose={CloseDocument} // onDeleteProblems={DeleteProblems} 
            setIsRecordSaved={() => { }}
            setSaveDocumentData={setSaveDocumentData}
            setAdditionalInfoData={setAdditionalInfoData}
            isOpenedFrom={'SOAP'}
        />
    }

    // useEffect(() => {
    //     const observer = new IntersectionObserver((entries) => {
    //         console.log("isOpenedFromobserversaveProblemsData", entries)
    //         entries
    //             .filter(ent => ent.isIntersecting)
    //             .forEach((entry, index) => {
    //                 if (index === 0 && entry.target.id.startsWith('ref-')) {
    //                     props?.setActiveID(entry.target.id);
    //                 }
    //             });
    //     }, {
    //         threshold: 0.8,
    //     });

    //     const elementsWithId = Array.from(document.querySelectorAll('[id]'));
    //     const filteredElements = elementsWithId.filter(el => el.id.startsWith('ref-'));

    //     filteredElements.forEach(el => observer.observe(el));

    //     return () => {
    //         filteredElements.forEach(el => observer.unobserve(el));
    //     };
    // }, []);

    const LoadVitalsData = () => {
        if (!searchParam?.EncounterDate) return;
        // setIsLoading(true);
        setPastVitalsLoaded(false);
        setVitalsPastData({})
        ServerRequestProtected(API_URL_PATIENTENCOUNTER + "/GetPastVital", 'post', {
            "TableName": enumUtil.enumAPITableName.Vital,
            "SearchCriteria": {
                "PatientID": patientID,
                "EncounterDate": searchParam.EncounterDate
            }
        })
            .then((response) => {
                // setIsLoading(false);
                setVitalsPastData(response);
                setPastVitalsLoaded(true);

                const hasChiefComplaint = !!initialData?.Data?.ChiefComplaint?.trim?.();
                let isVitalEmpty = initialData?.Vital?.length === 0 && response?.Vital?.length === 0;
                let isObservationDataEmpty = ((initialData?.CognitiveStatus?.length ?? 0) === 0 && (initialData?.FunctionalStatus?.length ?? 0) === 0);

                hasChiefComplaint &&
                    setItemsCollapsed(prev => ({ ...prev, ['V']: isVitalEmpty, ['O']: isObservationDataEmpty }));
            }).catch((error) => {
                // setIsLoading(false)
                setPastVitalsLoaded(false);
            })
    }

    useEffect(() => {
        LoadVitalsData();
        LoadDD(searchParam?.EncounterDate);
    }, [searchParam?.EncounterDate]);

    console.log("isOpenedFrom saveDocumentData", saveDocumentData)

    const handleAddProblemWithDefaultICD = (selectedData) => {
        setSelectedDiagnosisValue(selectedData)
        AddProblems(null);
    }
    const PatDx = () => {
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/CodesSearch", 'post', {
            "TableName": enumUtil.enumAPITableName.Diagnosis,
            "SEARCHCRITERIA": {
                "Param": "PatientProblems",
                "Search": null,
                "PatientID": patientID + "",
            },
            "value": "0",
            "PERPAGE": "100",
            "PAGENO": "1"
        }).then((response) => {
            setIsLoading(false)
            setPatDxData(response.Rows)
        }).catch((error) => {
            setIsLoading(false)
            setPatDxData([])
        })
    }

    useEffect(() => {
        if (!isNull(props?.patientID)) {
            PatDx();
            LoadLastEncounterProblem();
            LoadLastEncounterCPT();
        }
    }, [props?.patientID])

    useEffect(() => {
        if (!isNull(props?.patientID) && props?.isRecordSaved && props?.isRecordSavedType === 'Problems') {
            PatDx()
        }
    }, [props?.patientID, props?.isRecordSaved])

    const AddProblems = (ID, prob) => {
        setProblemsID(ID)
        setProblemModal(prob);
        setIsOpenProblems(prev => !prev);
    }
    const CloseProblems = () => {
        setIsOpenProblems(false)
    }
    let PopupScreenProblems = "";
    if (isOpenProblems) {
        PopupScreenProblems = <AddNewProblem isOpenProblems={isOpenProblems} problemsID={problemsID} setProblemsID={setProblemsID}
            patientID={patientID}
            onClose={CloseProblems} // onDeleteProblems={DeleteProblems} 
            // isOpen={}
            selectedDiagnosisValue={selectedDiagnosisValue}
            setSelectedDiagnosisValue={setSelectedDiagnosisValue}
            problemModal={problemModal}
            setProblemModal={setProblemModal}
            setIsRecordSaved={() => { }}
            setSaveProblemsData={setSaveProblemsData}
            setAssessmentData={setAssessmentData}
            isOpenedFrom={'SOAP'}
            IsEditAllowed={IsEditAllowed}
            IsDeleteAllowed={IsDeleteAllowed}
        />
    }

    const handleSelectedData = (selectedData, name, type, mode) => {
        setIs(true)
        let modal = { ...mainProblemsModal };
        if (type === 'client' && !isNull(selectedData)) {
        } else if (type === 'server' && !isNull(selectedData)) {
            if (name === 'ProblemName') {
                const exists = assessmentData?.EncounterProblem?.some(item => item.DiagnosisCodeID == selectedData.DiagnosisCodeID);
                if (exists) return;
                if (!selectedData.PatientProblemListID) {
                    selectedData.Acuity = selectedData.Acuity ? (selectedData.Acuity + "") : 'Undefined';
                    handleAddProblemWithDefaultICD(selectedData);
                    modal[name] = '';
                } else {
                    setAssessmentData(prev => {
                        let encounterLength = prev?.EncounterProblem?.length || 0;
                        // Check save state for deleted item
                        const savedItem = saveProblemsData.find(x => x.PatientProblemListID === selectedData.PatientProblemListID);
                        let mergedData = selectedData;

                        if (savedItem && savedItem.Deleted === "true") {
                            // Restore IDs from deleted item
                            mergedData = {
                                ...selectedData,                  // latest fields from UI
                                EncounterProblemID: savedItem.EncounterProblemID,
                                PatientProblemListID: savedItem.PatientProblemListID,
                                EncounterID: savedItem.EncounterID,
                                Deleted: "false"
                            };
                        }
                        // ----------------------------
                        // Check if exists in AssessmentData
                        // ----------------------------
                        const idExist = prev.EncounterProblem?.some(
                            item => item.PatientProblemListID === selectedData.PatientProblemListID
                        );

                        const updatedEncounterProblem = idExist
                            ? prev.EncounterProblem.map(item =>
                                item.PatientProblemListID === selectedData.PatientProblemListID
                                    ? {
                                        ...mergedData,
                                        recordNoClient: String(encounterLength + 1)
                                    }
                                    : item
                            )
                            : [...(prev.EncounterProblem || []), {
                                ...mergedData,
                                recordNoClient: String(encounterLength + 1)
                            }];

                        return { ...prev, EncounterProblem: updatedEncounterProblem };
                    });

                    //  Update SaveProblemsData
                    if (!selectedData?.EncounterProblemID) {
                        selectedData.EncounterProblemID = "";
                    }

                    setSaveProblemsData(prev => {
                        const prevItem = prev.find(x => x.DiagnosisCodeID === selectedData.DiagnosisCodeID);
                        console.log("prevItem12", prevItem)
                        if (prevItem) {
                            // Restore if it was deleted
                            const restoredItem = prevItem.Deleted === "true" ? { ...prevItem, Deleted: "false" } : prevItem;
                            // Merge latest fields from prob but keep IDs from restoredItem
                            return prev.map(item =>
                                item.PatientProblemListID === restoredItem.PatientProblemListID
                                    ? {
                                        ...item,          // keep existing data in prev array
                                        ...selectedData,          // apply latest fields
                                        EncounterProblemID: restoredItem.EncounterProblemID, PatientProblemListID: restoredItem.PatientProblemListID, EncounterID: restoredItem.EncounterID,
                                        Deleted: restoredItem.Deleted
                                    } : item
                            );
                        }
                        // If not in existingList, check if selectedData exists in prev
                        const idExist = prev.some(item => item.PatientProblemListID === selectedData.PatientProblemListID);
                        if (idExist) {
                            return prev.map(item =>
                                item.PatientProblemListID === selectedData.PatientProblemListID ? selectedData : item
                            );
                        } else {
                            return [...prev, selectedData];
                        }
                    });
                    modal[name] = '';
                }
            }
        } else {

            modal[name] = ''
            // problemsSaveUpdateModal[name] = ''
            if (name === 'ProblemName') {
                modal[name] = ''
                // setProblemNameSelected(false);
            }
        }
        setMainProblemsModal(modal);
        // setProblemsSaveUpdateModal(problemsSaveUpdateModal);
        return selectedData
    }
    const handleDeviceChange = (e) => {
        setIs(false)
        setMainProblemsModal(prev => ({ ...prev, ProblemName: e.target.value }));
        setIcdBody({ "TableName": enumUtil.enumAPITableName.Diagnosis, "SearchParam": e.target.value })
    }

    const ShowHideInActive = () => {

        // const condition = (item) => (item.isActive === "false") && !["", "0", 0, undefined].includes(item.EncounterProblemID)
        const condition = (item) => (item.isActive === "false");
        let inActiveCount = assessmentData?.EncounterProblem?.filter(condition).length;
        return inActiveCount > 0 ? <p className='heading validate-color cursor-pointer' onClick={() => setShowInActiveProblems(prev => !prev)}>
            {showInActiveProblems ? `Hide InActive(${inActiveCount})` : `Show InActive(${inActiveCount})`}
        </p> : null
    }

    const [isOpenNewDiagnosis, setisOpenNewDiagnosis] = useState(false)
    const [icdCode, setIcdCode] = useState()
    const [ActiveICDName, setActiveICDName] = useState('')

    let Procedure_Code_Modal = {
        CPT: "",
    }
    const [CPTModal, setCPTModal] = useState(Procedure_Code_Modal);
    const handleAddNewICD = (searchValue, name) => {
        setActiveICDName(name)
        setIcdCode(searchValue)
        setisOpenNewDiagnosis(true)
    }
    const handleCloseICD = () => {
        setisOpenNewDiagnosis(false)
    }
    const handleOnSaveICD = (selectedData) => {
        if (!isNull(ActiveICDName)) {
            handleSelectedData(selectedData, ActiveICDName, 'server')
        }
    }
    let PopupNewICD = ''
    if (isOpenNewDiagnosis) {
        PopupNewICD = <AddNewDiagnosis isOpenDiagnosis={isOpenNewDiagnosis} onClose={handleCloseICD} Diagnosisvalue={icdCode} onDeleteProcedure={handleCloseICD} onDeleteDiagnosis={handleCloseICD} IsOpen={true} onICDSave={handleOnSaveICD} />
    }
    const handleProblemDelete = (item) => {
        const { DiagnosisCodeID } = item;
        setAssessmentData(prev => {
            const filteredEncounterProblem = (prev.EncounterProblem || []).filter(
                p => p.DiagnosisCodeID !== DiagnosisCodeID
            );
            // console.log("DiagnosisCodeID", 
            //     DiagnosisCodeID,
            //     prev.EncounterProblem,
            //     filteredEncounterProblem
            // )
            return { ...prev, EncounterProblem: filteredEncounterProblem };
        });
        setSaveProblemsData(prev => {
            let found = false;

            const updated = prev.reduce((acc, p) => {
                if (p.DiagnosisCodeID === DiagnosisCodeID) {
                    found = true;
                    const isEncounterProblemIDNull = isNull(p.EncounterProblemID);
                    if (!isEncounterProblemIDNull) {
                        acc.push({ ...p, Deleted: "true" }); // mark as deleted
                    }
                    // else: skip (removes the item)
                } else {
                    acc.push(p); // keep others
                }
                return acc;
            }, []);

            if (!found) {
                updated.push({
                    DiagnosisCodeID: item?.DiagnosisCodeID,
                    EncounterID: item?.EncounterID,
                    EncounterProblemID: item?.EncounterProblemID,
                    PatientProblemListID: item?.PatientProblemListID,
                    Deleted: "true", // or whatever logic you need
                });
            }

            return updated;
        });

    }
    const handleDocumentDelete = (item, indexToRemove) => {
        const { PatientDocumentID, recordNoClient } = item;

        // Remove from EncounterDocument list by index
        setAdditionalInfoData(prev => {
            const updatedEncounterDocument = prev.EncounterDocument.filter((_, idx) => idx !== indexToRemove);
            return { ...prev, EncounterDocument: updatedEncounterDocument };
        });
        // Update saveDocumentData accordingly
        setSaveDocumentData(prev => {
            if (PatientDocumentID) {
                const exists = prev.some(doc => doc.PatientDocumentID === PatientDocumentID);

                if (exists) {
                    //  Update it to mark as deleted
                    return prev.map(doc =>
                        doc.PatientDocumentID === PatientDocumentID
                            ? { ...doc, Deleted: "true" }
                            : doc
                    );
                } else {
                    //  Push a new deleted object if it doesn't exist yet
                    return [
                        ...prev,
                        {
                            PatientDocumentID,
                            EncounterID: item.EncounterID,
                            Deleted: "true",
                        },
                    ];
                }
            } else if (recordNoClient) {
                //  Remove unsaved local doc entirely
                return prev.filter(doc => doc.recordNoClient !== recordNoClient);
            } else {
                return prev;
            }
        });
    }
    const textareaRef = useRef(null);

    const adjustTextareaHeight = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.setProperty('height', 'auto', 'important');
            textarea.style.setProperty('height', `${textarea.scrollHeight}px`, 'important');
        }
    };

    const componentRef = useRef(null);
    const { isLoading: isLoadingPdf, captureDataAndGeneratePDF } = useCaptureDataAndGeneratePDFBrowserAPI();
    // let DEFAULT_PREVIEW_SELECTED = {
    //     "patientSummary": true,
    //     "chiefComplaint": true,
    //     "vitals": true,
    //     "problems": true,
    //     "plan": true,
    //     "planNotes": true,
    //     "uiDesign" : false,
    // };
    // const [selectedItems, setSelectedItems] = useState(DEFAULT_PREVIEW_SELECTED);
    const [showAddressTypeLocation, setShowAddressTypeLocation] = useState('false');
    const handleEditProcedure = () => {
        if (!isSuperbillEditAllowed) return;
        setIsProcedureEdit(prev => !prev)
    }
    const { PatientName, Age, DOB, Address, MobileNumber, Email, } = initialData?.Data;

    // const [mainServiceLineModal, setMainServiceLineModal] = useState(initialData?.SuperBill);
    // const [mainServiceLineModalSaveData, setMainServiceLineModalSaveData] = useState([]);
    const [modifierBody, setmodifierBody] = useState({ "TableName": enumUtil.enumAPITableName.Modifier, "SearchParam": '' })
    const [cptBody, setcptBody] = useState({ "TableName": enumUtil.enumAPITableName.Procedure, "SearchParam": '' })

    const mainServiceLineModalSaveData = useMemo(() => {
        return mainServiceLineModal.filter(it => it.isUpdated === 'true').map(({ isUpdated, ...rest }) => rest);
    }, [mainServiceLineModal]);


    const handleServiceLineChange = (e, id, index, type, isMainCPTEncounterPhysicalNote) => {
        if (!isSuperbillEditAllowed) return;
        setIs(false)
        let { name, value } = e.target;
        if (type === 'ProcedureCode') {
            setcptBody({ "TableName": enumUtil.enumAPITableName.Procedure, "SearchParam": value })
        } else if (type === 'Modifier') {
            setmodifierBody({ "TableName": enumUtil.enumAPITableName.Modifier, "SearchParam": value })
        } else if (name === 'RevenueCode') {
            // setRevCodeBody({ "TableName": enumUtil.enumAPITableName.RevenueCode, "SearchParam": value })
        }
        if (isMainCPTEncounterPhysicalNote === "isMainCPTEncounterPhysicalNote") {
            setCPTModal(prev => ({ ...prev, CPT: value }))
        } else {
            let serviceLineItem = [...mainServiceLineModal];
            serviceLineItem[index][name] = value;
            serviceLineItem[index]['isUpdated'] = 'true';
            setMainServiceLineModal(serviceLineItem);
        }
        // if (name === 'PerUnitAmount') {
        // serviceLineItem[index]['Amount'] = parseFloat(serviceLineItem[index]['Units'] * value).toFixed(2)
        // serviceLineItem[index]['PrimaryBalance'] = parseFloat(serviceLineItem[index]['Units'] * value).toFixed(2)
        // serviceLineItem[index]['PrimaryBilledAmount'] = parseFloat(serviceLineItem[index]['Units'] * value).toFixed(2)
        // // calculateAmounts(mainServiceLineModal)
        // }
        // if (name === 'Units') {
        // serviceLineItem[index]['Amount'] = parseFloat(serviceLineItem[index]['PerUnitAmount'] * value).toFixed(2)
        // serviceLineItem[index]['PrimaryBalance'] = parseFloat(serviceLineItem[index]['PerUnitAmount'] * value).toFixed(2)
        // serviceLineItem[index]['PrimaryBilledAmount'] = parseFloat(serviceLineItem[index]['Units'] * value).toFixed(2)
        // // calculateAmounts(mainServiceLineModal)
        // }

    }

    // const handleOnblurServiceline = (e, index) => {
    //     const { value, name } = (e.target)
    //     let serviceLineItem = [...mainServiceLineModal];
    //     let serviceLineValidationCopy = JSON.parse(JSON.stringify(serviceLineValidation));
    //     if (name === 'Pointer1' || name === 'Pointer2' || name === 'Pointer3' || name === 'Pointer4') {
    //         let pointer1 = serviceLineItem[index]['Pointer1'] + ""
    //         let pointer2 = serviceLineItem[index]['Pointer2'] + ""
    //         let pointer3 = serviceLineItem[index]['Pointer3'] + ""
    //         let pointer4 = serviceLineItem[index]['Pointer4'] + ""
    //         let pointer = [pointer1, pointer2, pointer3, pointer4]
    //         let intValue = parseInt(value)
    //         let icdIndex = 'ICD' + value + 'Code'
    //         // debugger
    //         if (intValue < 1 || intValue > 12 && !isNaN(intValue)) {
    //             serviceLineValidationCopy[index][name + 'ICD'] = 'pointer value cannot be less than 1 and greater than 12'
    //         } else if (
    //             // isNull(mainDiagnosisModal[icdIndex]) &&
    //             icdIndex !== 'ICDCode') {
    //             // if (!isNull(icdIndex)) {
    //             //     if (isNull(value)) {
    //             //         serviceLineValidationCopy[index][name + 'ICD'] = ''
    //             //     } else {
    //             //         serviceLineValidationCopy[index]['Pointer1UNI'] = ''
    //             //         serviceLineValidationCopy[index][name + 'ICD'] = 'Cannot add pointer against empty ICD'
    //             //     }
    //             // }
    //         } else {
    //             serviceLineValidationCopy[index][name + 'ICD'] = ''
    //             const uniqueSet = new Set();
    //             let hasDuplicates = false;

    //             for (const item of pointer) {
    //                 if (!isNull(item)) {
    //                     if (uniqueSet.has(item)) {
    //                         hasDuplicates = true;
    //                         break;
    //                     }
    //                     uniqueSet.add(item);
    //                 }
    //             }

    //             if (hasDuplicates) {
    //                 serviceLineValidationCopy[index]['Pointer1UNI'] = 'Pointers must be unique'
    //             } else {
    //                 serviceLineValidationCopy[index]['Pointer1UNI'] = ''
    //             }
    //         }
    //         let foundNull = false;
    //         let Error = false;
    //         for (let i = 0; i < 4; i++) {
    //             if (isNull(pointer[i])) {
    //                 foundNull = true
    //             }
    //             if (!isNull(pointer[i]) && foundNull === true) {
    //                 Error = true
    //             }
    //         }
    //         if (Error) {
    //             serviceLineValidationCopy[index]['Pointer1Val'] = 'Pointers must be in sequence'
    //         } else {
    //             serviceLineValidationCopy[index]['Pointer1Val'] = ''
    //         }
    //         console.log("serviceLineValidationCopy",serviceLineValidationCopy)
    //         setServiceLineValidation(serviceLineValidationCopy)
    //     }
    // }
    const handleOnblurServiceline = (e, index) => {
        const { value, name } = e.target;
        let serviceLineItem = [...mainServiceLineModal];
        let serviceLineValidationCopy = JSON.parse(JSON.stringify(serviceLineValidation));

        // Ensure index exists
        if (!serviceLineValidationCopy[index]) {
            serviceLineValidationCopy[index] = {};
        }

        if (name === 'Pointer1' || name === 'Pointer2' || name === 'Pointer3' || name === 'Pointer4') {
            let pointer1 = (serviceLineItem[index]['Pointer1'] || '') + "";
            let pointer2 = (serviceLineItem[index]['Pointer2'] || '') + "";
            let pointer3 = (serviceLineItem[index]['Pointer3'] || '') + "";
            let pointer4 = (serviceLineItem[index]['Pointer4'] || '') + "";
            let pointer = [pointer1, pointer2, pointer3, pointer4];
            let intValue = parseInt(value);
            let icdIndex = 'ICD' + value + 'Code';

            if ((intValue < 1 || intValue > 12) && !isNaN(intValue)) {
                serviceLineValidationCopy[index][name + 'ICD'] = 'pointer value cannot be less than 1 and greater than 12';
            } else if (icdIndex !== 'ICDCode') {
                // Placeholder: previously commented logic — kept untouched to avoid affecting old functionality
            } else {
                serviceLineValidationCopy[index][name + 'ICD'] = '';

                const uniqueSet = new Set();
                let hasDuplicates = false;

                for (const item of pointer) {
                    if (!isNull(item)) {
                        if (uniqueSet.has(item)) {
                            hasDuplicates = true;
                            break;
                        }
                        uniqueSet.add(item);
                    }
                }

                serviceLineValidationCopy[index]['Pointer1UNI'] = hasDuplicates
                    ? 'Pointers must be unique'
                    : '';
            }

            // Check sequence validity
            let foundNull = false;
            let Error = false;
            for (let i = 0; i < 4; i++) {
                if (isNull(pointer[i])) {
                    foundNull = true;
                }
                if (!isNull(pointer[i]) && foundNull === true) {
                    Error = true;
                }
            }

            serviceLineValidationCopy[index]['Pointer1Val'] = Error
                ? 'Pointers must be in sequence'
                : '';

            console.log("serviceLineValidationCopy", serviceLineValidationCopy);
            setServiceLineValidation(serviceLineValidationCopy);
        }
    };


    console.log("mainServicelineModalProcedureCodeProcedureCode", mainServiceLineModal)
    let SERVICE_LINE_MODAL = {
        "SuperBillID": "",
        "ProcedureCodeID": "",
        "ProcedureCode": "",
        "Pointer1": "",
        "Pointer2": "",
        "Pointer3": "",
        "Pointer4": "",
        "ModifierCodeID1": "",
        "ModifierCode1": "",
        "ModifierCodeID2": "",
        "ModifierCode2": "",
        "ModifierCodeID3": "",
        "ModifierCode3": "",
        "ModifierCodeID4": "",
        "ModifierCode4": "",
        "Units": "1",
        "Deleted": "false",
        "isUpdated": "false",
    };
    let ServiceLineValidation_Modal = {
        // DOSFromVal: '',
        // DOSToVal: '',
        // CPTCodeVal: '',
        // ModifierCode1Val: '',
        // ModifierCode1UNI: '',
        // ModifierCode2Val: '',
        // ModifierCode2UNI: '',
        // ModifierCode3Val: '',
        // ModifierCode3UNI: '',
        // ModifierCode4Val: '',
        // ModifierCode4UNI: '',
        Pointer1Val: '',
        Pointer1UNI: '',
        Pointer2Val: '',
        Pointer2UNI: '',
        Pointer3Val: '',
        Pointer3UNI: '',
        Pointer4Val: '',
        Pointer4UNI: '',
        Pointer1ICD: '',
        Pointer2ICD: '',
        Pointer3ICD: '',
        Pointer4ICD: '',
        // POSVal: '',
        UnitsVal: '',
    }
    const [serviceLineValidation, setServiceLineValidation] = useState([])
    console.log("serviceLineValidationmainServicelineModalProcedureCodeProcedureCode ", serviceLineValidation)

    const handleSuperSearchList = (selectedData, index, name, isRecCPT, method) => {
        if (!isSuperbillEditAllowed) return;
        console.log("firsthandleSuperSearchList", selectedData, index, name, isRecCPT, method)
        // debugger
        let serviceLineValidationCopy = JSON.parse(JSON.stringify(serviceLineValidation));
        // console.log("ProcedureCodeProcedureCode",selectedData)
        let data
        if (isRecCPT === true) {
            if (method === 'CPT') {
                data = { value: selectedData[0].ProcedureCodeID, display: selectedData[0].ProcedureCode }
            } else {
                data = { value: selectedData[0].ProcedureMacroID, display: selectedData[0].Name }
                // handleSelectIcdFromProcedureMacro(selectedData[0], index, method)
            }
        } else if (isRecCPT === 'Modifier') {
            data = { value: selectedData[0].ModifierCodeID, display: selectedData[0].ModifierCode }
        } else {
            if (!isNull(selectedData)) {
                selectedData.isUpdated = "true";
                data = selectedData
            }
        }
        setIs(true)
        // let clas = document.getElementById('serviceLine')
        // clas.classList.add('ad-expand-table')
        let serviceLineItem = [...mainServiceLineModal];
        if (!isNull(data)) {
            console.log("ProcedureCodeProcedureCodedata", data)
            if (name === 'ProcedureCode') {
                let newItem;
                const existingItem = serviceLineItem?.find(it => it.ProcedureCodeID == String(data.value));

                if (existingItem) {
                    if (existingItem.Deleted === "true") {
                        console.log("Restored deleted item: Deleted === true", newItem);
                        // Deleted case: restore item
                        newItem = {
                            ...SERVICE_LINE_MODAL,
                            ProcedureCodeID: data.value + "",
                            [name]: data.display,          // latest UI update
                            SuperBillID: existingItem.SuperBillID || "",
                            isUpdated: "true",
                            // Keep any other fields you want to preserve from SERVICE_LINE_MODAL or existingItem
                        };

                        // Replace the deleted item in the array
                        const index = serviceLineItem.indexOf(existingItem);
                        if (index !== -1) serviceLineItem[index] = newItem;
                        console.log("Restored deleted item:", newItem);
                        // Update validation because item was restored
                        const newValidationlist = JSON.parse(JSON.stringify(serviceLineValidation));
                        newValidationlist.push(ServiceLineValidation_Modal);
                        setServiceLineValidation(newValidationlist);

                    }
                } else {
                    console.log("Restored deleted item: NEW", newItem);
                    // Entirely new item → add to array
                    newItem = {
                        ...SERVICE_LINE_MODAL,
                        ProcedureCodeID: data.value + "",
                        [name]: data.display,
                        isUpdated: "true",
                    };
                    serviceLineItem.push(newItem);
                    // Update validation for the new item
                    const newValidationlist = JSON.parse(JSON.stringify(serviceLineValidation));
                    newValidationlist.push(ServiceLineValidation_Modal);
                    setServiceLineValidation(newValidationlist);
                }
                // serviceLineValidationCopy[index]['CPTCodeVal'] = ''
                if (method === 'CPT') {
                    // GetClaimTypeDD(data.value, index)
                }
            } else if (name === 'ModifierCode1') {
                serviceLineItem[index]['ModifierCodeID1'] = data.value + ""
                serviceLineItem[index][name] = data.display
                serviceLineItem[index]['isUpdated'] = data.isUpdated;

            } else if (name === 'ModifierCode2') {
                serviceLineItem[index]['ModifierCodeID2'] = data.value + ""
                serviceLineItem[index][name] = data.display
                serviceLineItem[index]['isUpdated'] = data.isUpdated;
            } else if (name === 'ModifierCode3') {
                serviceLineItem[index]['ModifierCodeID3'] = data.value + ""
                serviceLineItem[index][name] = data.display
                serviceLineItem[index]['isUpdated'] = data.isUpdated;
            } else if (name === 'ModifierCode4') {
                serviceLineItem[index]['ModifierCodeID4'] = data.value + ""
                serviceLineItem[index][name] = data.display
                serviceLineItem[index]['isUpdated'] = data.isUpdated;
            } else if (name === 'POSCode') {
                // serviceLineItem[index]['POSCodeID'] = data.value + ""
                // // serviceLineItem[index][name] = data.display
                // serviceLineItem[index]['POSCode'] = data.code + ""
                // serviceLineValidationCopy[index]['POSVal'] = ''

            } else if (name === 'RevenueCode') {
                // serviceLineItem[index]['RevenueCodeID'] = data.value + ""
                // serviceLineItem[index][name] = data.code
            }
        } else {
            console.log("ModifierCode1ModifierCode1", data, name)
            if (name === 'ModifierCode1') {
                serviceLineItem[index]['ModifierCodeID1'] = ""
                serviceLineItem[index][name] = ''
                // serviceLineItem[index]['isUpdated'] = data.isUpdated; 

            } else if (name === 'ModifierCode2') {
                serviceLineItem[index]['ModifierCodeID2'] = ""
                serviceLineItem[index][name] = ''
                // serviceLineItem[index]['isUpdated'] = data.isUpdated; 
            } else if (name === 'ModifierCode3') {
                serviceLineItem[index]['ModifierCodeID3'] = ""
                serviceLineItem[index][name] = ''
                // serviceLineItem[index]['isUpdated'] = data.isUpdated; 
            } else if (name === 'ModifierCode4') {
                serviceLineItem[index]['ModifierCodeID4'] = ""
                serviceLineItem[index][name] = ''
                // serviceLineItem[index]['isUpdated'] = data.isUpdated; 
            }
            console.log("ModifierCode1ModifierCode1 serviceLineItem", serviceLineItem[index])
        }
        if (method === 'CPT') {
            setMainServiceLineModal(serviceLineItem)
            if (name === 'ProcedureCode') {
                setCPTModal(prev => ({ ...prev, CPT: '' }))
            }
            //   setServiceLineValidation(serviceLineValidationCopy)
        }
        if (isRecCPT === 'Modifier') {
            //   handleOnblurModifiers(data.value, name, index)
        }

    }

    const CPTValidation = () => {
        let allValid = true;
        let serviceLineValidationCopy = JSON.parse(JSON.stringify(serviceLineValidation));

        mainServiceLineModal.forEach((item, index) => {
            if (!serviceLineValidationCopy[index]) {
                serviceLineValidationCopy[index] = {};
            }

            const pointerFields = ['Pointer1', 'Pointer2', 'Pointer3', 'Pointer4'];
            let pointerValues = pointerFields.map(p => (item[p] || "") + "");

            let uniqueSet = new Set();
            let hasDuplicates = false;
            let foundNull = false;
            let hasSequenceError = false;

            pointerFields.forEach((pointerName, i) => {
                const value = item[pointerName];
                const intValue = parseInt(value);
                const icdIndex = 'ICD' + value + 'Code';

                // ✅ Pointer1 Required check
                if (pointerName === 'Pointer1' && (isNull(value) || value === '')) {
                    serviceLineValidationCopy[index][pointerName + 'ICD'] = 'Pointer 1 is Required';
                    allValid = false;
                    return;
                }

                // Range check
                if ((intValue < 1 || intValue > 12) && !isNaN(intValue)) {
                    serviceLineValidationCopy[index][pointerName + 'ICD'] = 'Pointer value must be between 1 and 12';
                    allValid = false;
                } else if (icdIndex !== 'ICDCode') {
                    // Valid, clear any error
                    serviceLineValidationCopy[index][pointerName + 'ICD'] = '';
                }

                // Duplicate check
                if (!isNull(value)) {
                    if (uniqueSet.has(value)) {
                        hasDuplicates = true;
                    }
                    uniqueSet.add(value);
                }

                // Sequence check
                if (isNull(pointerValues[i])) {
                    foundNull = true;
                }
                if (!isNull(pointerValues[i]) && foundNull === true) {
                    hasSequenceError = true;
                }
            });

            serviceLineValidationCopy[index]['Pointer1UNI'] = hasDuplicates ? 'Pointers must be unique' : '';
            serviceLineValidationCopy[index]['Pointer1Val'] = hasSequenceError ? 'Pointers must be in sequence' : '';

            // Units Required check
            if (!item?.Units || isNaN(item?.Units) || parseFloat(item?.Units) <= 0) {
                serviceLineValidationCopy[index]['UnitsVal'] = 'Units Required';
                allValid = false;
            } else {
                serviceLineValidationCopy[index]['UnitsVal'] = '';
            }

            if (hasDuplicates || hasSequenceError) {
                allValid = false;
            }
        });

        setServiceLineValidation(serviceLineValidationCopy);

        let isNotValid = !allValid;
        if (isNotValid) {
            setIsProcedureEdit(true);
        }
        return isNotValid;
    };



    //    const CPTValidation = () => {
    //     let allValid = true;
    //     const newValidation = [];

    //     mainServiceLineModal.forEach((item, index) => {
    //         const validationItem = {};

    //         ['Pointer1', 'Pointer2', 'Pointer3', 'Pointer4'].forEach(pointerName => {
    //             const value = item[pointerName];

    //             // Call existing validation logic
    //             const result = handleOnblurServiceline(
    //                 { target: { value, name: pointerName } },
    //                 index
    //             );
    //             console.log("result",result)
    //             // Assume it returns true/false or updates state directly
    //             if (result === false) {
    //                 allValid = false;
    //             }

    //             // If handleOnblurServiceline updates state internally,
    //             // you may skip this block and instead read from serviceLineValidation after loop
    //         });

    //         newValidation.push(validationItem); // Optional if not setting custom messages here
    //     });

    //     // Optionally set newValidation if handleOnblurServiceline is *not* updating state
    //     // setServiceLineValidation(newValidation);

    //     return allValid;
    //     };



    useImperativeHandle(ref, () => ({
        CPTValidation
    }));

    const handleQualityOfCare = (e) => {
        let { name } = e.target;
        setQualityOfCareData(prev => ({
            ...prev,
            [name]: prev[name] === "true" ? "false" : "true"
        }));

        setSaveQualityOfCareData(prev => ({
            ...prev,
            [name]: prev[name] === "true" ? "false" : "true"
        }));
    }
    let areAllValuesNullOrEmpty = (obj) => {
        console.log("CheckValidationobj", obj)
        for (let key in obj) {
            if (obj[key] !== null && obj[key] !== "") {
                return false;
            }
        }
        return true;
    }
    const handleDeleteRow = (index) => {
        console.log("indexindexindexindex", index, mainServiceLineModal)
        const data = [...mainServiceLineModal];
        const validationList = [...serviceLineValidation];

        if (!data[index]?.SuperBillID) {
            // Hard delete → remove row & validation
            data.splice(index, 1);
            validationList.splice(index, 1);
        } else {
            // Soft delete → mark deleted & updated
            data[index].Deleted = "true";
            data[index].isUpdated = "true";
            // Optionally mark the corresponding validation entry as deleted
            if (validationList[index]) {
                validationList[index] = JSON.parse(JSON.stringify(ServiceLineValidation_Modal));
            }
        }
        setMainServiceLineModal(data);
        setServiceLineValidation(validationList);
    };
    const handleViewClaim = () => {
        if (!isClaimViewAllowed) return;
        let obj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                id: initialData.Data.ClaimID,
                name: initialData.Data.PatientName,
                time: new Date(),
                visitType: initialData.Data?.ClaimType,
                EncounterID: initialData?.Data?.EncounterID,
                PatientID: initialData?.Data?.PatientID,
            },
        };
        setOpenTab(obj)
    }
    const handleCreateClaim = () => {
        if (!isCreateClaimEditAllowed) return;
        let dataForClaim = {
            EncounterID: initialData?.Data?.EncounterID,
            PatientID: initialData?.Data?.PatientID,
            PatientName: initialData?.Data?.PatientName,
        }
        let dataObj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                name: "New Professional",
                id: -1,
                time: new Date(),
                visitType: "P",
                EncounterID: dataForClaim
            },
        };
        setOpenTab(dataObj)
    }

    const [isOpenProcedure, setisOpenProcedure] = useState(false)
    const [ActiveCode, setActiveCode] = useState('')
    const [ActiveCodeindex, setActiveCodeindex] = useState('')
    const [ActiveCodeName, setActiveCodeName] = useState('')

    const handleAddNewCPT = (searchValue, name, index) => {
        if (!isNull(searchValue)) {
            setActiveCode(searchValue)
            // setActiveCodeindex(index)
        } else {
            setActiveCode('')
        }
        setisOpenProcedure(true)
    }
    const handleCloseCPT = () => {
        setisOpenProcedure(false)
    }
    const handleClearState = () => {
        setActiveCode('')
        // setActiveCodeindex()
        setActiveCodeName('')
    }
    const handleOnSaveCPT = (selectedData) => {
        // handleSuperSearchList(selectedData, ActiveCodeindex, 'ProcedureCode', false, 'CPT')
        handleSuperSearchList(selectedData, 'index', 'ProcedureCode', false, 'CPT')
        handleClearState();
    }
    let ProcedurePopup = ''
    if (isOpenProcedure) {
        ProcedurePopup = <AddNewProcedureCodes isOpenProcedure={isOpenProcedure} onClose={handleCloseCPT} ProcedureCode={ActiveCode} onDeleteProcedure={handleCloseCPT} handleOnSaveICD={handleOnSaveCPT} isOpenFromList={true} />
    }
    ////////////// Problems ///////////////
    const [lastEncounterProblems, setLastEncounterProblems] = useState({})

    const LoadLastEncounterProblem = () => {
        if (!searchParam?.EncounterDate) return;
        setLastEncounterProblems({})
        ServerRequestProtected(API_URL_GENERAL + "/FindByMultipleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.EncounterProblem,
            "ID": patientID,
            "SearchCriteria": {
                "EncounterDate": searchParam.EncounterDate
            }
        })
            .then((response) => {
                setLastEncounterProblems({
                    EncounterDate: response?.count?.EncounterDate,
                    Problems: response?.Rows || []
                });
                // setPastVitalsLoaded(true);
            }).catch((error) => {
                // setIsLoading(false)
            })
    }
    ////////////// CPT ///////////////
    const [lastEncounterCPTs, setLastEncounterCPTs] = useState({})

    const LoadLastEncounterCPT = () => {
        if (!searchParam?.EncounterDate) return;
        setLastEncounterCPTs({})
        ServerRequestProtected(API_URL_PATIENTENCOUNTER + "/LastEncounterCPT", 'post', {
            "TableName": enumUtil.enumAPITableName.Encounter,
            "ID": patientID,
            "SearchCriteria": {
                "EncounterDate": searchParam.EncounterDate
            }
        })
            .then((response) => {
                setLastEncounterCPTs({
                    EncounterDate: response?.count?.EncounterDate,
                    CPTs: response?.Rows || []
                });
                // setPastVitalsLoaded(true);
            }).catch((error) => {
                // setIsLoading(false)
            })
    }

    const handleApplyProblems = () => {
        const getNewProblems = (existingList = [], type) => {
            const existingCodes = new Set(existingList.map(prob => prob.DiagnosisCode));
            let updatedArr = (lastEncounterProblems?.Problems || []).filter(prob => !existingCodes.has(prob.DiagnosisCode)).map(({ EncounterID, ...it }) => (it));
            //  FIX Deleted and Added existing record before saving ====////===== Case HERE
            updatedArr = updatedArr.map(prob => {
                const prevItem = existingList.find(x => x.DiagnosisCode === prob.DiagnosisCode);
                if (prevItem) {
                    // If it was deleted → restore Deleted flag
                    const restoredItem = prevItem.Deleted === "true" ? { ...prevItem, Deleted: "false" } : prevItem;
                    // Merge IDs from prevItem but keep latest fields from prob
                    return {
                        ...prob, // latest fields
                        // EncounterID: restoredItem.EncounterID,
                        EncounterProblemID: restoredItem.EncounterProblemID,
                        PatientProblemListID: restoredItem.PatientProblemListID,
                        Deleted: restoredItem.Deleted // keep restored Deleted if applicable
                    };
                }

                return prob;
            });

            if (type === 'Save') {
                let viewExistingCodes = new Set((assessmentData?.EncounterProblem || []).map(prob => prob.DiagnosisCode));
                updatedArr = updatedArr.map(prob => {
                    if (viewExistingCodes.has(prob.DiagnosisCode)) {
                        let viewItem = assessmentData.EncounterProblem.find(assessProb => prob.DiagnosisCode === assessProb.DiagnosisCode)
                        return {
                            ...prob,
                            EncounterID: viewItem.EncounterID,
                            EncounterProblemID: viewItem.EncounterProblemID,
                            PatientProblemListID: viewItem.PatientProblemListID
                        };
                    } else {
                        return prob;
                    }
                })
            }
            return updatedArr;
        };


        setSaveProblemsData(prev => {
            let saveExisting = [...getNewProblems(prev, 'Save')];
            const newProbs = [...prev, ...saveExisting];
            return newProbs;
        });

        setAssessmentData(prev => {
            const existingList = prev?.EncounterProblem || [];
            const newProbs = [...existingList, ...getNewProblems(existingList, 'View')];
            return {
                ...prev,
                EncounterProblem: newProbs
            };
        });
    };

    const handleApplyCPTs = () => {
        if (!isSuperbillEditAllowed) return;

        const existingCodes = new Set(mainServiceLineModal.map(prob => prob.ProcedureCodeID));
        let newValidationList = [...serviceLineValidation];

        let restoredItems = [];
        let untouchedItems = [];

        // Split existing rows into restored vs untouched
        mainServiceLineModal.forEach(item => {
            const replacement = (lastEncounterCPTs?.CPTs || []).find(
                prob => item.ProcedureCodeID == prob.ProcedureCodeID
            );

            if (item.Deleted === "true" && replacement) {
                // Restore deleted item using replacement fields
                let { EncounterID, EncounterDate, Description, Deleted, ...rest } = replacement;
                console.log("replacement11", replacement)
                restoredItems.push({
                    ...rest,
                    isUpdated: "true",
                    Deleted: "false",
                    SuperBillID: item.SuperBillID,   // KEEP original SuperBillID
                });

                // Add validation ONLY for restored row
                newValidationList.push(ServiceLineValidation_Modal);

            } else {
                // Keep normal items in order
                untouchedItems.push(item);
            }
        });

        // NEW CPTs (not in modal)
        const newCPTs = (lastEncounterCPTs?.CPTs || [])
            .filter(prob => !existingCodes.has(prob.ProcedureCodeID))
            .map(cpt => {
                let { EncounterID, EncounterDate, Description, Deleted, ...rest } = cpt;
                rest["isUpdated"] = "true";

                // Add validation for truly new items
                newValidationList.push(ServiceLineValidation_Modal);

                return rest;
            });

        // Final ordering:
        // 1. Untouched items stay where they are
        // 2. Restored items move to the end
        // 3. Newly added CPTs come after restored
        const finalList = [
            ...untouchedItems,
            ...restoredItems,
            ...newCPTs
        ];

        setMainServiceLineModal(finalList);
        setServiceLineValidation(newValidationList);
    };
    const { insertPosition } = props;
    const scrollNavIDs = useMemo(() => {
        const id = encounterID || ''; // safe fallback
        return {
            ...([ 'Top', 'Bottom'].includes(insertPosition) ? { refCF: `ref-CF${id}` } : {}),

            refSUBJECTIVECC: `ref-SUBJECTIVE-CC${id}`,

            refASSESSMENTP: `ref-ASSESSMENT-P${id}`,

            // refSUBJECTIVE: `ref-SUBJECTIVE${id}`,
            refSUBJECTIVEN: `ref-SUBJECTIVE-N${id}`,

            // OBJECTIVE (3)
            refOBJECTIVE: `ref-OBJECTIVE${id}`,
            refOBJECTIVEOBS: `ref-OBJECTIVE-Obs${id}`,
            refOBJECTIVEPA: `ref-OBJECTIVE-PA${id}`,
            refOBJECTIVEPAL: `ref-OBJECTIVE-P${id}`,
            refOBJECTIVEROM: `ref-OBJECTIVE-R${id}`,
            refOBJECTIVESTR: `ref-OBJECTIVE-S${id}`,
            refOBJECTIVETANDM: `ref-OBJECTIVE-TANDM${id}`,
            refOBJECTIVEN: `ref-OBJECTIVE-N${id}`,

            // ASSESSMENT (3)
            // refASSESSMENT: `ref-ASSESSMENT${id}`,
            // refASSESSMENTAT: `ref-ASSESSMENT-AT${id}`,
            // refASSESSMENTFA: `ref-ASSESSMENT-FA${id}`,
            // refASSESSMENTMU: `ref-ASSESSMENT-MU${id}`,
            refASSESSMENTN: `ref-ASSESSMENT-N${id}`,

            // PLAN (2)
            refPLAN: `ref-PLAN${id}`,
            refPLANN: `ref-PLAN-N${id}`,
            refPLANHEPN: `ref-PLAN-HEPN${id}`,
            refPLANFollowUp: `ref-PLAN-FollowUp${id}`,

            // ADDITIONAL INFO (3)
            refAdditionalINFO: `ref-AdditionalINFO${id}`,
            refAdditionalINFODOC: `ref-AdditionalINFO-DOC${id}`,
            refAdditionalINFON: `ref-AdditionalINFO-N${id}`,
        };
    }, [encounterID, insertPosition]);
                    
    /////////////Navigate to newly added custom template on import //////////////
    const handleNavigateToCustomTemplate = (id) => {
        // props?.setActiveID(id);
        const elementBar = document?.getElementById(`${id}`);
        if (elementBar) {
            elementBar.scrollIntoView({ behavior: 'smooth' });
        }
    }
    useEffect(() => {
        if(!scrollNavIDs?.refCF || ![ 'Top', 'Bottom'].includes(insertPosition) || props?.saveCustomTemplateData?.length === 0) return;
        console.log("saveCustomTemplateData123", props?.saveCustomTemplateData)
        handleNavigateToCustomTemplate(scrollNavIDs.refCF);
    },[scrollNavIDs?.refCF])
    /////////////////////////////////////////////////////////////////////////////


    return (
        <>
            {openTab ? <ContentReceiver data={openTab} setOpenTab={setOpenTab} /> : null}
            {ProcedurePopup}
            {showPreview ?
                <EncounterPreview data={initialData} searchParam={searchParam} setSearchParam={setSearchParam} searchValue={searchValue}

                    mainServiceLineModal={mainServiceLineModal}
                    setMainServiceLineModal={setMainServiceLineModal}
                    serviceLineValidation={serviceLineValidation}
                    handleOnblurServiceline={handleOnblurServiceline}
                    handleServiceLineChange={handleServiceLineChange}
                    handleDeleteRow={handleDeleteRow}
                    modifierBody={modifierBody}
                    handleSuperSearchList={handleSuperSearchList}
                    handleApplyCPTs={handleApplyCPTs}
                    isProcedureEdit={isProcedureEdit}
                    CPTModal={CPTModal}
                    cptBody={cptBody}
                    RecentModifiers={RecentModifiers}
                    // RecentCPTs={RecentCPTs}
                    areAllValuesNullOrEmpty={areAllValuesNullOrEmpty}
                    handleCreateClaim={handleCreateClaim}
                    handleViewClaim={handleViewClaim}
                    handleEditProcedure={handleEditProcedure}
                    handleAddNewCPT={handleAddNewCPT}
                    mainServiceLineModalSaveData={mainServiceLineModalSaveData}

                    getSaveData={props?.getSaveData}
                    patientID={patientID}
                    encounterID={encounterID}
                    setReloadAfterSave={props?.setReloadAfterSave}
                    defaultSelectedItems={defaultSelectedItems}
                    Data={
                        {
                            ...(subjectiveData || {}),
                            ...(objectiveData || {}),
                            ...(assessmentData || {}),
                            ...(planData || {}),
                            // "ObjectiveNotes": objectiveData?.ObjectiveNotes,
                            // "AssesmentNotes": assessmentData?.AssesmentNotes,
                            // "PlanNotes": planData?.PlanNotes,

                            // "PrescriptionsNotes": planData?.PrescriptionsNotes || "",
                            // "SupplementsNotes": planData?.SupplementsNotes || "",
                            // "VaccinesNotes": planData?.VaccinesNotes || "",
                            // "InjectionsNotes": planData?.InjectionsNotes || "",
                            // "LabsNotes": planData?.LabsNotes || "",
                            // "ImagingNotes": planData?.ImagingNotes || "",
                            "FollowUpDate": planData?.FollowUpDate || "",
                            "FollowUpNotes": planData?.FollowUpNotes || "",
                            "AdditionalInfoNotes": additionalInfoData?.AdditionalInfoNotes,
                            "EncounterProblem": assessmentData?.EncounterProblem,
                            "EncounterDocument": additionalInfoData?.EncounterDocument,
                            "QualityOfCare": qualityOfCareData,
                            "CustomTemplateData": props?.customTemplateData

                            // "ObservationsData": observationsData,
                            // "vitalData": vitalData,
                            // "HistoryOfPresentIllness": subjectiveData?.HistoryOfPresentIllness,
                            // "ReviewOfSystem": subjectiveData?.ReviewOfSystem,
                        }} /> :
                <div className="d-flex flex-column gap-10 pt-1-5">
                    <SignEncounter isSign={isSign} setIsSign={setIsSign} providerName={initialData?.Data?.ProviderName  || ''} setSearchParam={setSearchParam}
                        getSaveData={props?.getSaveData} initialDataData={initialData?.Data || {}} />
                    {PopupScreenProblems}
                    {PopupScreenDocument}
                    {PopupNewICD}
                    {insertPosition === 'Top' &&
                        <div className="" id={scrollNavIDs.refCF} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refCF)} onClick={() => handleActiveItem(scrollNavIDs.refCF)}>
                            <CustomTemplateForm customTemplateData={props?.customTemplateData} setCustomTemplateData={props?.setCustomTemplateData} setSaveCustomTemplateData={props?.setSaveCustomTemplateData} validations={props?.validations} itemsCollapsed={itemsCollapsed} handleItemsExpanded={handleItemsExpanded}/>
                        </div>}
                    <div className="" id={scrollNavIDs.refSUBJECTIVECC} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refSUBJECTIVECC)} onClick={() => handleActiveItem(scrollNavIDs.refSUBJECTIVECC)}>
                        <p className="text fs-13 font-b validate-color blue-bg" onClick={() => handleItemsExpanded('CC')}>Chief Complaint</p>
                        {!itemsCollapsed?.['CC'] &&
                            (<div className="input mt-1">
                                <div className={"input"}>
                                    <textarea
                                        className="form-control"
                                        ref={textareaRef}
                                        onInput={adjustTextareaHeight}
                                        name="ChiefComplaint"
                                        id="ChiefComplaint"
                                        autoComplete='off'
                                        // placeholder="Add Chief Complaint here..."
                                        value={subjectiveData.ChiefComplaint}
                                        onChange={(e) => handleChange(e, 'Subjective')}
                                    />
                                </div>
                            </div>)}
                    </div>

                    {defaultSelectedItems?.problems &&
                        <div onMouseEnter={() => handleHoveredItem(scrollNavIDs.refASSESSMENTP)} onClick={() => handleActiveItem(scrollNavIDs.refASSESSMENTP)}>
                            <div className="d-flex justify-content-between align-items-center" id={scrollNavIDs.refASSESSMENTP} >
                                <p className="text fs-13 font-b validate-color blue-bg" onClick={() => handleItemsExpanded('P')}>Problems</p>
                                <div className="d-flex gap-2 align-items-center">
                                    <div className="all_problems-preview position-relative">
                                        {lastEncounterProblems?.Problems?.length > 0 ?
                                            <>
                                                <p className='text validate-color br-right-1 br-clr pe-2 cursor-pointer user-select-none' onClick={handleApplyProblems}>{lastEncounterProblems?.EncounterDate} - Problems</p>
                                                <div className="problem-content d-flex flex-column gap-2 hover-scrollbar">
                                                    {lastEncounterProblems?.Problems?.map(prob => (
                                                        <div className="d-flex align-items-center justify-content-between gap-20">
                                                            <p className="text font-m">{prob.DiagnosisCode}</p>
                                                            <p className="text font-m text-nowrap singleLine-ellispis">{prob?.Description}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                            </> : <></>}
                                    </div>
                                    <div className='input claims_info problems-search'>
                                        <i className='icon-Clip-path-group top-50 translate-middle-y'></i>
                                        <div className="position-relative za-denied-status Icds">
                                            <SuperICDandCPTSearch
                                                type='server'
                                                key={PatDxData?.length}
                                                placeholder={'Add Problem'}
                                                customData={RecentICDs}
                                                id='Dx'
                                                name='ProblemName'
                                                onChange={handleDeviceChange}
                                                getSelectedData={handleSelectedData}
                                                searchValue={mainProblemsModal.ProblemName}
                                                searchBy={['display', 'Description']}
                                                tableData={[
                                                    { columName: 'Code', bindingValue: 'display', },
                                                    { columName: 'Description', bindingValue: 'Description', },
                                                ]}
                                                ApiLink={API_URL + "/ICDInstantSearch"}
                                                method='post'
                                                postBody={icdBody}
                                                disabled={true}
                                                // ScrollOutside={false}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                                // isItemSelected={!isNull(mainDiagnosisModal.ICD6Code) ? true : false}
                                                handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                                PatDxData={PatDxData}
                                                showPatDx={true}
                                                DefaultActiveTab='MyDXList'
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {!itemsCollapsed?.['P'] &&
                                (<>
                                    {assessmentData?.EncounterProblem?.length > 0 &&
                                        (<div className="d-flex flex-column gap-2 hover-scrollbar problem-scroll px-1-5 py-2 assesment-box mb-12 mt-1">
                                            {/* {console.log("assessmentData?.EncounterProblem12345", assessmentData?.EncounterProblem)} */}

                                            {(assessmentData?.EncounterProblem?.length > 0 ?
                                                <>
                                                    {assessmentData?.EncounterProblem.map(item => {
                                                        // let inActive = handleInActiveProblems(item.EndDate);
                                                        // let isSaved = !["", "0", 0, undefined].includes(item.EncounterProblemID);
                                                        // let inActive = !(item.isActive === "true");
                                                        let inActive = item?.isActive ? !(item.isActive === "true") : false;
                                                        let isSaved = true;

                                                        if (inActive && !showInActiveProblems && isSaved) return;
                                                        return (
                                                            <div className="d-flex align-items-center justify-content-between gap-1">
                                                                <div className="d-flex align-items-center gap-1 w-100">
                                                                    <p className="text validate-color cursor-pointer font-m" onClick={() => AddProblems(item.PatientProblemListID, item)}> {item.DiagnosisCode}</p>

                                                                    {item.Description ?
                                                                        <p className="text singleLine-ellispis"> - {item.Description}</p> :
                                                                        (item.Description &&
                                                                            <p className="text singleLine-ellispis"> - {item.Description}</p>)}
                                                                </div>

                                                                <div className="d-flex gap-10 align-items-center ps-10">
                                                                    <div className="d-flex align-items-center gap-1 text-nowrap">
                                                                        {item.StartDate ?
                                                                            <>
                                                                                <p className="text font-m">Start Date:</p>
                                                                                <p className="text">{item.StartDate}</p>
                                                                            </> : <></>}
                                                                        {item.isActive === "true" ? <></> :
                                                                            item.isActive === "false" ?
                                                                                <p className="text Partialdenied-clr fst-italic text-nowrap br-left-1 br-clr-light ps-1">InActive </p> :
                                                                                <></>}
                                                                    </div>
                                                                    <div className="lh-1">
                                                                        <i className='icon-x-cros fs-20 dark-clr' onClick={() => handleProblemDelete(item)}></i>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                    <ShowHideInActive />
                                                </> :
                                                <>
                                                </>)}
                                        </div>
                                        )}</>)}
                        </div>
                    }

                    <div id={scrollNavIDs.refSUBJECTIVEN} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refSUBJECTIVEN)} onClick={() => handleActiveItem(scrollNavIDs.refSUBJECTIVEN)}>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="ar_header d-flex gap-6 align-items-center mb-1 w-100" onClick={() => handleAccordionChange('SUBJECTIVE')}>
                                {activeAccord['SUBJECTIVE'] ? <i className="icon-up fs-10 pt-2px"></i> : <i className="icon-down fs-10 pt-2px"></i>}
                                <p className="text fs-13 font-b validate-color blue-bg">S - SUBJECTIVE</p>
                            </div>
                            <div className="orange-alert text-nowrap user-select-none">
                                <div className='ar-alert d-flex m-0 me-1 py-1'>
                                    {/* <i className='fs-13 icon-alert lh-16 m-0'></i>
                                <p className="text ms-1"><span className='validate-color cursor-pointer text-decoration-underline'>Click here</span> to associate this encounter with appointment.</p> */}
                                </div>
                            </div>
                        </div>
                        {activeAccord['SUBJECTIVE'] ?
                            <div className='d-flex flex-column gap-1 SUBJECTIVE-CC'>
                                <div >
                                    {/* <p className="heading fs-13 cursor-pointer user-select-none w-max-content" onClick={() => handleItemsExpanded('SN')}>Notes</p>
                                        {!itemsCollapsed?.['SN'] &&
                                            ( */}
                                    <div className='mt-1'>
                                        <TextEditor
                                            quillRef={quillSubjectiveNotesRef}
                                            value={subjectiveData.SubjectiveNotes}
                                            setValue={(value) => handleChangeFreeText(value, 'Subjective')}
                                            placeholderReplacement={true}
                                            customDropDown={{
                                                'active': true,
                                                'options': [
                                                    // { value: '', display: 'Add Patient Info', },
                                                    { value: PatientName, display: '$Name', },
                                                    { value: Age, display: '$Age', },
                                                    { value: DOB, display: '$DOB', },
                                                    { value: Address, display: '$Address', },
                                                    { value: MobileNumber, display: '$Phone', },
                                                    { value: Email, display: '$Email', },
                                                ]
                                            }}
                                            placeholder={"Subjective information discussed in session, such as report of symptoms..."}
                                        />
                                    </div>
                                    {/* )
                                        } */}
                                </div>
                                {/* } */}
                            </div> : <></>}
                    </div>

                    <div id={scrollNavIDs.refOBJECTIVE}>
                        <div className="ar_header d-flex gap-6 align-items-center mb-1" onClick={() => handleAccordionChange('OBJECTIVE')}>
                            {activeAccord['OBJECTIVE'] ? <i className="icon-up fs-10 pt-2px"></i> : <i className="icon-down fs-10 pt-2px"></i>}
                            <p className="text fs-13 font-b validate-color blue-bg">O - OBJECTIVE</p>
                        </div>
                        {activeAccord['OBJECTIVE'] &&
                            <div className={`d-flex gap-12 justify-content-between ar_pt-note-objective ${isCollapsed ? 'ar-problem-area-collasped' : ''}`}>
                                <div className='w-100 d-flex flex-column gap-1 position-relative'>
                                    {defaultSelectedItems?.observationNotes &&
                                        <div id={scrollNavIDs.refOBJECTIVEOBS} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refOBJECTIVEOBS)} onClick={() => handleActiveItem(scrollNavIDs.refOBJECTIVEOBS)}>
                                            <p className="heading fs-13 cursor-pointer user-select-none w-max-content" onClick={() => handleItemsExpanded('OBS')}>Observations</p>
                                            {!itemsCollapsed?.['OBS'] &&
                                                (
                                                    <div className='mt-1'>
                                                        <TextEditor
                                                            quillRef={quillObservationNotesRef}
                                                            value={objectiveData.ObservationNotes}
                                                            setValue={(value) => handleChangeFreeText(value, 'Observations')}
                                                            placeholderReplacement={true}
                                                            customDropDown={{
                                                                'active': true,
                                                                'options': [
                                                                    { value: PatientName, display: 'Name', },
                                                                    { value: Age, display: '$Age', },
                                                                    { value: DOB, display: '$DOB', },
                                                                    { value: Address, display: '$Address', },
                                                                    { value: MobileNumber, display: '$Phone', },
                                                                    { value: Email, display: '$Email', },
                                                                ]
                                                            }}
                                                            showIcon={true}
                                                            placeholder={"Observations..."}
                                                        />
                                                    </div>
                                                )}
                                        </div>}
                                    {defaultSelectedItems?.palpationNotes &&
                                        <div id={scrollNavIDs.refOBJECTIVEPAL} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refOBJECTIVEPAL)} onClick={() => handleActiveItem(scrollNavIDs.refOBJECTIVEPAL)}>
                                            <p className="heading fs-13 cursor-pointer user-select-none w-max-content" onClick={() => handleItemsExpanded('PAL')}>Palpation</p>
                                            {!itemsCollapsed?.['PAL'] &&
                                                (
                                                    <div className='mt-1'>
                                                        <TextEditor
                                                            quillRef={quillPalpationNotesRef}
                                                            value={objectiveData.PalpationNotes}
                                                            setValue={(value) => handleChangeFreeText(value, 'Palpation')}
                                                            placeholderReplacement={true}
                                                            customDropDown={{
                                                                'active': true,
                                                                'options': [
                                                                    { value: PatientName, display: 'Name', },
                                                                    { value: Age, display: '$Age', },
                                                                    { value: DOB, display: '$DOB', },
                                                                    { value: Address, display: '$Address', },
                                                                    { value: MobileNumber, display: '$Phone', },
                                                                    { value: Email, display: '$Email', },
                                                                ]
                                                            }}
                                                            showIcon={true}
                                                            placeholder={"Detail findings inculding tenderness, muscle tightness..."}
                                                        />
                                                    </div>
                                                )}
                                        </div>
                                    }
                                    {defaultSelectedItems?.rangeOfMotion &&
                                        <div className="d-flex flex-column gap-1" id={scrollNavIDs.refOBJECTIVEROM} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refOBJECTIVEROM)} onClick={() => handleActiveItem(scrollNavIDs.refOBJECTIVEROM)}>
                                            <p className="heading fs-13 letter-spacing-1-3 cursor-pointer" onClick={() => handleItemsExpanded('ROM')}>Range of Motion</p>
                                            {!itemsCollapsed?.['ROM'] &&
                                                <>
                                                    {/* {objectiveFinding?.RangeOfMotion === "true" ? */}
                                                    <RangeOfMotion
                                                        setSaveRangeOfMotionData={setSaveRangeOfMotionData}
                                                        objectiveData={objectiveData}
                                                        setObjectiveData={setObjectiveData}
                                                    />
                                                </>
                                                // <ObjectiveFinding 
                                                //     isExpanded = {itemsCollapsed?.['ObjFindings']}
                                                //     setSaveObjectiveFindingData={setSaveObjectiveFindingData} 
                                                //     setSaveRangeOfMotionData={setSaveRangeOfMotionData}
                                                //     objectiveData={objectiveData} 
                                                //     setObjectiveData={setObjectiveData} 

                                                //     ObjectiveNotesProps = {
                                                //         {
                                                //             // ObjectiveNotes: objectiveData.ObjectiveNotes,
                                                //             handleChangeFreeText,
                                                //             handleItemsExpanded,
                                                //             itemsCollapsed,
                                                //             scrollNavIDs,
                                                //             handleHoveredItem,
                                                //             handleActiveItem,
                                                //             PatientName,
                                                //             Age,
                                                //             DOB,
                                                //             Address,
                                                //             MobileNumber,
                                                //             Email,
                                                //         }
                                                //     }
                                                // />

                                            }
                                        </div>
                                    }
                                    {defaultSelectedItems?.strength &&
                                        <div className="d-flex flex-column gap-1" id={scrollNavIDs.refOBJECTIVESTR} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refOBJECTIVESTR)} onClick={() => handleActiveItem(scrollNavIDs.refOBJECTIVESTR)}>
                                            <p className="heading fs-13 letter-spacing-1-3 cursor-pointer" onClick={() => handleItemsExpanded('ObjFindings')}>Strength</p>
                                            {!itemsCollapsed?.['ObjFindings'] &&
                                                <>
                                                    {/* {objectiveFinding?.Strength === "true" ? */}
                                                    <Strength
                                                        setSaveStrengthData={setSaveStrengthData}
                                                        objectiveData={objectiveData}
                                                        setObjectiveData={setObjectiveData}
                                                    />
                                                </>
                                                // <ObjectiveFinding 
                                                //     isExpanded = {itemsCollapsed?.['ObjFindings']}
                                                //     setSaveObjectiveFindingData={setSaveObjectiveFindingData} 
                                                //     setSaveRangeOfMotionData={setSaveRangeOfMotionData}
                                                //     objectiveData={objectiveData} 
                                                //     setObjectiveData={setObjectiveData} 

                                                //     ObjectiveNotesProps = {
                                                //         {
                                                //             // ObjectiveNotes: objectiveData.ObjectiveNotes,
                                                //             handleChangeFreeText,
                                                //             handleItemsExpanded,
                                                //             itemsCollapsed,
                                                //             scrollNavIDs,
                                                //             handleHoveredItem,
                                                //             handleActiveItem,
                                                //             PatientName,
                                                //             Age,
                                                //             DOB,
                                                //             Address,
                                                //             MobileNumber,
                                                //             Email,
                                                //         }
                                                //     }
                                                // />

                                            }
                                        </div>
                                    }
                                    {defaultSelectedItems?.testMeasurementNotes &&
                                        <div id={scrollNavIDs.refOBJECTIVETANDM} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refOBJECTIVETANDM)} onClick={() => handleActiveItem(scrollNavIDs.refOBJECTIVETANDM)}>
                                            <p className="heading fs-13 cursor-pointer user-select-none w-max-content" onClick={() => handleItemsExpanded('TANDM')}>Tests & Measurements(Sensory, Special Tests)</p>
                                            {!itemsCollapsed?.['TANDM'] &&
                                                (
                                                    <div className='mt-1'>
                                                        <TextEditor
                                                            quillRef={quillTestMeasurementsNotesRef}
                                                            value={objectiveData.TestMeasurementNotes}
                                                            setValue={(value) => handleChangeFreeText(value, 'TestMeasurementNotes')}
                                                            placeholderReplacement={true}
                                                            customDropDown={{
                                                                'active': true,
                                                                'options': [
                                                                    { value: PatientName, display: 'Name', },
                                                                    { value: Age, display: '$Age', },
                                                                    { value: DOB, display: '$DOB', },
                                                                    { value: Address, display: '$Address', },
                                                                    { value: MobileNumber, display: '$Phone', },
                                                                    { value: Email, display: '$Email', },
                                                                ]
                                                            }}
                                                            showIcon={true}
                                                            placeholder={"Detail sensory evaluation any special tests performed relevant to the patient's condition..."}
                                                        />
                                                    </div>
                                                )}
                                        </div>
                                    }
                                    <div id={scrollNavIDs.refOBJECTIVEN} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refOBJECTIVEN)} onClick={() => handleActiveItem(scrollNavIDs.refOBJECTIVEN)}>
                                        <p className="heading fs-13 cursor-pointer user-select-none w-max-content" onClick={() => handleItemsExpanded('ON')}>Notes</p>
                                        {!itemsCollapsed?.['ON'] &&
                                            (
                                                <div className='mt-1'>
                                                    <TextEditor
                                                        quillRef={quillObjectiveNotesRef}
                                                        value={objectiveData.ObjectiveNotes}
                                                        setValue={(value) => handleChangeFreeText(value, 'Objective')}
                                                        placeholderReplacement={true}
                                                        customDropDown={{
                                                            'active': true,
                                                            'options': [
                                                                { value: PatientName, display: 'Name', },
                                                                { value: Age, display: '$Age', },
                                                                { value: DOB, display: '$DOB', },
                                                                { value: Address, display: '$Address', },
                                                                { value: MobileNumber, display: '$Phone', },
                                                                { value: Email, display: '$Email', },
                                                            ]
                                                        }}
                                                        showIcon={true}
                                                        placeholder={"Objective information discussed during the session..."}
                                                    />
                                                </div>
                                            )}
                                    </div>

                                    <div className="collaspe-sidebar d-flex justify-content-center align-items-center position-absolute" onClick={handleCollapseClick}>
                                        <i className="icon-angle-left  fs-11"></i>
                                    </div>
                                </div>

                                {defaultSelectedItems?.problemArea &&
                                    <div id={scrollNavIDs.refOBJECTIVEPA} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refOBJECTIVEPA)} onClick={() => handleActiveItem(scrollNavIDs.refOBJECTIVEPA)} className='ar-problem-area-content'>
                                        <ProblemArea
                                            setSaveFrontBodyDiagramData={setSaveFrontBodyDiagramData}
                                            setSaveBackBodyDiagramData={setSaveBackBodyDiagramData}
                                            objectiveData={objectiveData}
                                            setObjectiveData={setObjectiveData}
                                        />
                                    </div>}
                            </div>}
                    </div>
                    <div id={scrollNavIDs.refASSESSMENTN}>
                        <div className="ar_header d-flex gap-6 align-items-center mb-1" onClick={() => handleAccordionChange('ASSESSMENT')}>
                            {activeAccord['ASSESSMENT'] ? <i className="icon-up fs-10 pt-2px"></i> : <i className="icon-down fs-10 pt-2px"></i>}
                            <p className="text fs-13 font-b validate-color blue-bg" id='ASSESSMENT'>A - ASSESSMENT</p>
                        </div>
                        {activeAccord['ASSESSMENT'] &&
                            <div className='d-flex flex-column gap-1'>
                                {/* <div id={scrollNavIDs.refASSESSMENTN} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refASSESSMENTN)} onClick={() => handleActiveItem(scrollNavIDs.refASSESSMENTN)}> */}
                                {/* <p className="heading fs-13 cursor-pointer user-select-none w-max-content" onClick={() => handleItemsExpanded('AN')}>Notes</p> */}
                                {/* {!itemsCollapsed?.['AN'] &&
                                        ( */}
                                <div className="mt-1">
                                    <TextEditor
                                        quillRef={quillAssessmentRef}
                                        value={assessmentData.AssesmentNotes}
                                        setValue={(value) => handleChangeFreeText(value, 'Assessment')}
                                        placeholderReplacement={true}
                                        customDropDown={{
                                            'active': true,
                                            'options': [
                                                { value: PatientName, display: '$Name', },
                                                { value: Age, display: '$Age', },
                                                { value: DOB, display: '$DOB', },
                                                { value: Address, display: '$Address', },
                                                { value: MobileNumber, display: '$Phone', },
                                                { value: Email, display: '$Email', },
                                            ]
                                        }}
                                        placeholder={"Detail assessment based on subjective & objective information..."}
                                    />
                                </div>
                                {/* )} */}
                                {/* </div> */}
                            </div>}
                    </div>


                    <div id={scrollNavIDs.refPLAN}>
                        <div className="ar_header d-flex gap-6 align-items-center mb-1" onClick={() => handleAccordionChange('PLAN')}>
                            {activeAccord['PLAN'] ? <i className="icon-up fs-10 pt-2px"></i> : <i className="icon-down fs-10 pt-2px"></i>}
                            <p className="text fs-13 font-b validate-color blue-bg">P - PLAN</p>
                        </div>
                        {activeAccord['PLAN'] &&
                            <div className='d-flex flex-column gap-1'>

                                <div className="" id={scrollNavIDs.refPLANN} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refPLANN)} onClick={() => handleActiveItem(scrollNavIDs.refPLANN)}>
                                    <p className="heading fs-13 cursor-pointer user-select-none w-max-content" onClick={() => handleItemsExpanded('PN')}>Notes</p>
                                    {!itemsCollapsed?.['PN'] &&
                                        (
                                            <div className="mt-1">
                                                <TextEditor
                                                    quillRef={quillPlanRef}
                                                    value={planData.PlanNotes}
                                                    setValue={(value) => handleChangeFreeText(value, 'Plan')}
                                                    placeholderReplacement={true}
                                                    customDropDown={{
                                                        'active': true,
                                                        'options': [
                                                            { value: PatientName, display: '$Name', },
                                                            { value: Age, display: '$Age', },
                                                            { value: DOB, display: '$DOB', },
                                                            { value: Address, display: '$Address', },
                                                            { value: MobileNumber, display: '$Phone', },
                                                            { value: Email, display: '$Email', },
                                                        ]
                                                    }}
                                                    placeholder={"Next steps in the treatment process..."}
                                                />
                                            </div>
                                        )}
                                </div>

                                {defaultSelectedItems?.homeExerciseProgram &&
                                    <div className="" id={scrollNavIDs.refPLANHEPN} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refPLANHEPN)} onClick={() => handleActiveItem(scrollNavIDs.refPLANHEPN)}>
                                        <p className="heading fs-13 cursor-pointer user-select-none w-max-content" onClick={() => handleItemsExpanded('HEP')}>Home Exercise Program(HEP)</p>
                                        {!itemsCollapsed?.['HEP'] &&
                                            (
                                                <div className="mt-1">
                                                    <TextEditor
                                                        quillRef={quillHEPRef}
                                                        value={planData.HomeExerciseProgram}
                                                        setValue={(value) => handleChangeFreeText(value, 'HomeExerciseProgram')}
                                                        placeholderReplacement={true}
                                                        customDropDown={{
                                                            'active': true,
                                                            'options': [
                                                                { value: PatientName, display: '$Name', },
                                                                { value: Age, display: '$Age', },
                                                                { value: DOB, display: '$DOB', },
                                                                { value: Address, display: '$Address', },
                                                                { value: MobileNumber, display: '$Phone', },
                                                                { value: Email, display: '$Email', },
                                                            ]
                                                        }}
                                                        placeholder={"Home Exercise Program..."}
                                                    />
                                                </div>
                                            )}
                                    </div>
                                }

                                {defaultSelectedItems?.followUp &&
                                    <div className="" id={scrollNavIDs.refPLANFollowUp} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refPLANFollowUp)} onClick={() => handleActiveItem(scrollNavIDs.refPLANFollowUp)}>
                                        <p className="heading fs-13 cursor-pointer user-select-none w-max-content mb-1" onClick={() => handleItemsExpanded('FollowUp')}>Follow-Up</p>
                                        {!itemsCollapsed?.['FollowUp'] &&
                                            <div className='observation-content d-flex flex-column gap-2'>
                                                <div className='input w-25'>
                                                    <DatePicker
                                                        label={'Date'}
                                                        id="FollowUpDate"
                                                        value={planData.FollowUpDate}
                                                        handleCalendarChangefunc={date => setPlanData(prev => ({ ...prev, 'FollowUpDate': date }))}
                                                    />
                                                </div>
                                                <div className="">
                                                    <p className="heading fs-13 cursor-pointer user-select-none w-max-content mb-1" >Notes</p>
                                                    <div className="">
                                                        <TextEditor
                                                            quillRef={quillFollowUpRef}
                                                            value={planData.FollowUpNotes}
                                                            setValue={(value) => handleChangeFreeText(value, 'FollowUpNotes')}
                                                            placeholderReplacement={true}
                                                            customDropDown={{
                                                                'active': true,
                                                                'options': [
                                                                    { value: PatientName, display: '$Name', },
                                                                    { value: Age, display: '$Age', },
                                                                    { value: DOB, display: '$DOB', },
                                                                    { value: Address, display: '$Address', },
                                                                    { value: MobileNumber, display: '$Phone', },
                                                                    { value: Email, display: '$Email', },
                                                                ]
                                                            }}
                                                            placeholder={"Detail followup notes..."}
                                                        />
                                                    </div>
                                                </div>
                                            </div>}
                                    </div>
                                }
                            </div>}
                    </div>
                    
                    {insertPosition === 'Bottom' && 
                        <div className="" id={scrollNavIDs.refCF} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refCF)} onClick={() => handleActiveItem(scrollNavIDs.refCF)}>
                            <CustomTemplateForm customTemplateData={props?.customTemplateData} setCustomTemplateData={props?.setCustomTemplateData} setSaveCustomTemplateData={props?.setSaveCustomTemplateData}  validations={props?.validations} itemsCollapsed={itemsCollapsed} handleItemsExpanded={handleItemsExpanded} />
                        </div>}
                                 
                    {(defaultSelectedItems?.documents || defaultSelectedItems?.additionalNotes) &&
                        (
                            <div id={scrollNavIDs.refAdditionalINFO}>
                                <div className="ar_header d-flex gap-6 align-items-center mb-1" onClick={() => handleAccordionChange('AdditionalINFO')}>
                                    {activeAccord['AdditionalINFO'] ? <i className="icon-up fs-10 pt-2px"></i> : <i className="icon-down fs-10 pt-2px"></i>}
                                    <p className="text fs-13 font-b validate-color blue-bg">I - Additional INFO</p>
                                </div>
                                {activeAccord['AdditionalINFO'] &&
                                    <div className='d-flex flex-column gap-1'>
                                        {defaultSelectedItems?.documents &&
                                            <div onMouseEnter={() => handleHoveredItem(scrollNavIDs.refAdditionalINFODOC)} onClick={() => handleActiveItem(scrollNavIDs.refAdditionalINFODOC)}>
                                                <div className="d-flex justify-content-between align-items-center" id={scrollNavIDs.refAdditionalINFODOC}>
                                                    <p className="heading fs-13 cursor-pointer" onClick={() => handleItemsExpanded('D')}>Documents</p>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <div onClick={() => AddDocument({ PatientDocumentID: null })}>
                                                            <i className="icon-dash-plus add-icon rounded-5 fs-20" ></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                {!itemsCollapsed?.['D'] && (<>
                                                    {additionalInfoData?.EncounterDocument?.length > 0 &&
                                                        <div className="py-2 px-1-5 assesment-box mb-1 d-flex flex-column gap-2">

                                                            {additionalInfoData?.EncounterDocument.map((doc, index) => {
                                                                let docType = DropdownValueHandler(DropDowns.DocumentType, doc.DocumentTypeID)
                                                                return (
                                                                    <>
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <p className='text validate-color cursor-pointer text-nowrap br-right-1 br-clr-light pe-2' onClick={() => AddDocument(doc)}>{doc.FileName}</p>
                                                                            <p className="text font-m text-nowrap">Document Type:</p>
                                                                            <p className={`text text-nowrap pe-2 ${doc.Description ? 'br-right-1 br-clr-light' : ''} `}>{docType}</p>

                                                                            {doc.Description ? <p className="text font-m text-nowrap">Description:</p> : <></>}
                                                                            <p className='text text-nowrap validation_message w-100'>{doc.Description}</p>
                                                                            <div className="d-flex gap-10 align-items-center ps-10">
                                                                                <div className="lh-1">
                                                                                    <i className='icon-x-cros fs-20 dark-clr' onClick={() => handleDocumentDelete(doc, index)}></i>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )
                                                            })}
                                                        </div>}
                                                </>)}
                                            </div>
                                        }
                                        {defaultSelectedItems?.additionalNotes &&
                                            <div className="" id={scrollNavIDs.refAdditionalINFON} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refAdditionalINFON)} onClick={() => handleActiveItem(scrollNavIDs.refAdditionalINFON)}>
                                                <p className="heading fs-13 cursor-pointer user-select-none w-max-content" onClick={() => handleItemsExpanded('IN')}>Notes</p>
                                                {!itemsCollapsed?.['IN'] &&
                                                    (
                                                        <div className="mt-1">
                                                            <TextEditor
                                                                quillRef={quillAdditionalInfoRef}
                                                                value={additionalInfoData.AdditionalInfoNotes}
                                                                setValue={(value) => handleChangeFreeText(value, 'AdditionalInfo')}
                                                                placeholderReplacement={true}
                                                                customDropDown={{
                                                                    'active': true,
                                                                    'options': [
                                                                        { value: PatientName, display: '$Name', },
                                                                        { value: Age, display: '$Age', },
                                                                        { value: DOB, display: '$DOB', },
                                                                        { value: Address, display: '$Address', },
                                                                        { value: MobileNumber, display: '$Phone', },
                                                                        { value: Email, display: '$Email', },
                                                                    ]
                                                                }}
                                                            />
                                                        </div>
                                                    )}
                                            </div>
                                        }
                                    </div>}
                            </div>
                        )}
                    {defaultSelectedItems?.qualityOfCare &&
                        (
                            <div className='bg_yellow p-2'>
                                <p className='heading font-b fs-13 mb-1 leter-spacing'>Quality of Care</p>
                                <div className="ar_content">
                                    <div className="d-flex gap-40 align-items-center">

                                        <div className="d-flex flex-column gap-2">

                                            <label className="d-flex align-items-center gap-6">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        name="SummaryOfCareSent"
                                                        checked={qualityOfCareData?.SummaryOfCareSent === "true"}
                                                        onChange={handleQualityOfCare}
                                                    />
                                                </div>
                                                <p className="text">Summary of care sent</p>
                                            </label>

                                            <label className="d-flex align-items-center gap-6">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        name="IncomingTransferOfPatient"
                                                        checked={qualityOfCareData?.IncomingTransferOfPatient === "true"}
                                                        onChange={handleQualityOfCare}
                                                    />
                                                </div>
                                                <p className="text">Incoming transfer of care</p>
                                            </label>

                                            <label className="d-flex align-items-center gap-6">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        name="OutgoingTransferOfCare"
                                                        checked={qualityOfCareData?.OutgoingTransferOfCare === "true"}
                                                        onChange={handleQualityOfCare}
                                                    />
                                                </div>
                                                <p className="text">Outgoing transfer of care</p>
                                            </label>
                                        </div>
                                        <div className="d-flex flex-column gap-2">
                                            <label className="d-flex align-items-center gap-6">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        name="EducationMaterialGiven"
                                                        checked={qualityOfCareData?.EducationMaterialGiven === "true"}
                                                        onChange={handleQualityOfCare}
                                                    />
                                                </div>
                                                <p className="text">Education material given</p>
                                            </label>
                                            <label className="d-flex align-items-center gap-6">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        name="PatientDeclinedSummary"
                                                        checked={qualityOfCareData?.PatientDeclinedSummary === "true"}
                                                        onChange={handleQualityOfCare}
                                                    />
                                                </div>
                                                <p className="text">Patient declined summary</p>
                                            </label>
                                            <label className="d-flex align-items-center gap-6">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        name="VirtualVisit"
                                                        checked={qualityOfCareData?.VirtualVisit === "true"}
                                                        onChange={handleQualityOfCare}
                                                    />
                                                </div>
                                                <p className="text">Virtual visit</p>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                    <div className='bg_yellow p-2'>
                        <div className="d-flex align-items-center justify-content-between">
                            <p className='heading font-b fs-13 mb-1 leter-spacing' id={`SuperBill-${initialData?.Data?.EncounterID}`} >SUPERBILL</p>
                            <>
                                {!isNull(initialData?.Data?.EncounterID) &&
                                    (!isNull(initialData?.Data?.ClaimID) ?
                                        (<div className={`d-flex align-items-center cursor-pointer ${isClaimViewAllowed ? '' : 'disable'}`}>
                                            <p className='heading fs-11 validate-color' onClick={handleViewClaim}>View Claim</p>
                                            <i className='icon-enrollment fs-13 lh-9'></i>
                                        </div>) :
                                        <div className={`d-flex align-items-center cursor-pointer ${isCreateClaimEditAllowed ? '' : 'disable'}`}>
                                            {(dataExist ?
                                                (divClaimLinking) :
                                                (
                                                    mainServiceLineModal?.some(serviceLine => !isNull(serviceLine.SuperBillID)) ?
                                                        <div className='d-flex align-items-center cursor-pointer' onClick={handleCreateClaim}>
                                                            <p className={`heading fs-11 validate-color`}>Create Claim</p>
                                                            <i className='icon-enrollment fs-13 lh-9'></i>
                                                        </div>
                                                        :
                                                        <></>

                                                ))}
                                        </div>
                                    )}
                            </>
                        </div>
                        <div className="ar_content mb-2">
                            <div className="d-flex align-items-center gap-1 icds-content">
                                <p className='heading pe-1'>ICD(s)</p>
                                {assessmentData?.EncounterProblem?.length > 0 &&
                                    (assessmentData?.EncounterProblem?.map(prob => (
                                        <p className='text'>{prob?.DiagnosisCode}</p>
                                    )))}
                            </div>
                        </div>
                        <div className="d-flex align-items-center gap-1 mb-1 justify-content-between">
                            <div className='d-flex align-items-center gap-1'>
                                <p className='heading font-b fs-13 leter-spacing'>Procedure Codes</p>
                                <div className={`d-flex ${isSuperbillEditAllowed ? '' : 'disable'}`}>
                                    {isProcedureEdit ?
                                        <i className='icon-x-cros gray-clr fw-900 fs-11"' onClick={handleEditProcedure}></i> :
                                        <i className='icon-Icon-material-edit ar-light-color fs-11' onClick={handleEditProcedure}></i>}
                                </div>
                            </div>
                            <div className={`d-flex align-items-center gap-1 ${isSuperbillEditAllowed ? '' : 'disable'}`}>
                                <div className="all_problems-preview position-relative">
                                    {lastEncounterCPTs?.CPTs?.length > 0 ?
                                        <>
                                            <p className={`text validate-color cursor-pointer user-select-none ${isProcedureEdit ? 'br-right-1 br-clr pe-2' : ''}`} onClick={handleApplyCPTs}>{lastEncounterCPTs?.EncounterDate} - CPTs</p>
                                            <div className="problem-content d-flex flex-column gap-2 hover-scrollbar ">
                                                {lastEncounterCPTs?.CPTs?.map(cpt => (
                                                    <div className="d-flex align-items-center justify-content-between gap-20">
                                                        <p className="text font-m">{cpt.ProcedureCode}</p>
                                                        <p className="text font-m text-nowrap singleLine-ellispis" title={cpt?.Description}>{cpt?.Description}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        </> : <></>}
                                </div>
                                {isProcedureEdit ?
                                    <div className='input claims_info problems-search'>

                                        <i className='icon-Clip-path-group top-50 translate-middle-y'></i>
                                        <div className="position-relative za-denied-status Icds">

                                            <SuperICDandCPTSearch
                                                type='server'
                                                customData={RecentCPTs}
                                                placeholder={'Add Procedure'}
                                                id='ProcedureCode'
                                                name='ProcedureCode'
                                                onChange={(e) => handleServiceLineChange(e, 'data.RowID', 'index', 'ProcedureCode', 'isMainCPTEncounterPhysicalNote')}
                                                getSelectedData={(singlerow) => handleSuperSearchList(singlerow, 'index', 'ProcedureCode', false, 'CPT')}
                                                searchValue={CPTModal.CPT}
                                                searchBy={['display', 'Description']}
                                                tableData={[
                                                    { columName: 'Code', bindingValue: 'display', },
                                                    { columName: 'Description', bindingValue: 'Description', },
                                                ]}
                                                ApiLink={API_URL + "/CPTInstantSearch"}
                                                method='post'
                                                postBody={cptBody}
                                                disabled={true}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                                handleAddNewCode={(searchValue, name) => handleAddNewCPT(searchValue, name, 'index')}
                                                // inputError={!isNull(serviceLineValidation[index]?.CPTCodeVal) ? true : false}
                                                // isItemSelected={!isNull(data.ProcedureCode) ? true : false}
                                                // handleonFocus={handleOnFocusServiceline}
                                                // handleOnblur={handleOnBlurForHover}
                                                isReadOnly={!isSuperbillEditAllowed}
                                            />
                                            {/* <SuperICDandCPTSearch
                                            key={PatDxData?.length}
                                            type='server'
                                            customData={RecentICDs}
                                            id='Dx'
                                            name='ProblemName'
                                            onChange={handleDeviceChange}
                                            getSelectedData={handleSelectedData}
                                            searchValue={mainProblemsModal.ProblemName}
                                            searchBy={['display', 'Description']}
                                            tableData={[
                                                { columName: 'Code', bindingValue: 'display', },
                                                { columName: 'Description', bindingValue: 'Description', },
                                            ]}
                                            ApiLink={API_URL + "/ICDInstantSearch"}
                                            method='post'
                                            postBody={icdBody}
                                            disabled={true}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                            // isItemSelected={!isNull(mainDiagnosisModal.ICD6Code) ? true : false}
                                            handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                            PatDxData={PatDxData}
                                            showPatDx={true}
                                            DefaultActiveTab='MyDXList'
                                        /> */}
                                        </div>
                                    </div> : <></>}
                            </div>
                        </div>
                        <div className="hk-expand-table overflow-auto BorderLess-table">
                            <table className="w-100">
                                <thead>
                                    <tr>
                                        <th>Code</th>
                                        <th className='w-212px'>Modifiers</th>
                                        <th className='w-130px'>Pointers</th>
                                        <th className='w-130px'>Units</th>
                                        {isProcedureEdit ? <th className='w-0px'></th> : <></>}
                                    </tr>
                                </thead>
                                {isProcedureEdit ?
                                    <tbody>
                                        <>
                                            {mainServiceLineModal?.map((data, index) => {
                                                console.log("dataServiceLineInfo", data);
                                                // let processedAsDD = []
                                                // let displayProcedureCode= DropdownValueHandler(processedAsDD, data.ProcessedAs);
                                                let displayProcedureCode = data?.ProcedureCode;
                                                console.log("dataServiceLineInfoindex1", serviceLineValidation);
                                                console.log("dataServiceLineInfoindex2", serviceLineValidation[index]);
                                                let CheckValidation = areAllValuesNullOrEmpty(serviceLineValidation[index])
                                                console.log("CheckValidation", CheckValidation)
                                                // let amountVals = amountValidationModal?.[data?.ServiceLineID];
                                                let amountVals = {}?.[data?.ServiceLineID];
                                                const AmountValidationExist = amountVals ? Object.values(amountVals).some(value => value) : null;
                                                // let errorText = handleValidationErrorText(amountVals);
                                                // let datas = {
                                                // name: 'Claims',
                                                // data: {
                                                //     id: data?.ClaimID,
                                                //     name: item?.PatientInfo?.NM1_03_NameFirst,
                                                //     ClaimRecord: claimRecord,
                                                // }
                                                // };
                                                // data.TransferToSecondary === null && handleTransferToSecondary(VISIT_PAYMENT_index,index,data);
                                                let VISIT_PAYMENT_index = '';
                                                if (data?.Deleted !== "true") {
                                                    return (
                                                        <>
                                                            <tr key={data.ServiceLineID}>
                                                                {/* <td></td> */}
                                                                <td className='position-relative'>
                                                                    <div className='input select-bg-img'>
                                                                        {/* <select
                                                    type="text"
                                                    className="pe-3 form-control new_insure_payment sm"
                                                    name="ProcessedAs"
                                                    id="ProcessedAs"
                                                    value={data.ProcessedAs}
                                                    onChange={(e) => handleTableChange(e, VISIT_PAYMENT_index, index, data)}
                                                    onKeyPress={(event) => handleNumericCheck(event)}>
                                                    {processedAsDD.map(option => (
                                                        <option key={option.value} value={option.value}>
                                                        {option.display}
                                                        </option>
                                                    ))}
                                                    </select> */}
                                                                        {/* <SuperSearchList
                                                    type="client"
                                                    id='ProcessedAs'
                                                    name='ProcessedAs'
                                                    searchValue={displayProcedureCode}
                                                    data={processedAsDD}
                                                    onChange={(e) => {setIs(false);handleTableChange(e, VISIT_PAYMENT_index, index, data)}}
                                                    getSelectedData={(e) => {setIs(true);handleSuperSearchChange(e,VISIT_PAYMENT_index,index,data,'ProcessedAs')}}
                                                    is={is}
                                                    icon={'Simple'}
                                                    sup_btn='sup_btn'
                                                    sup_inp='superSearchVisitInp'
                                                    disabled={false}
                                                    placeholder={false}
                                                    ScrollOutside={true}
                                                    /> */}
                                                                        {displayProcedureCode}
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className='hk-table-flex' >
                                                                        <div
                                                                        // className={isFocused ? "" : 'za-denied-status'} onMouseEnter={handleMouseEnter}
                                                                        >
                                                                            <SuperICDandCPTSearch
                                                                                type='server'
                                                                                customData={RecentModifiers}
                                                                                id='Modifier Code'
                                                                                name='ModifierCode1'
                                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                                                                getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode1', '', 'CPT')}
                                                                                searchValue={data.ModifierCode1}
                                                                                searchBy={['display', 'Description']}
                                                                                tableData={[
                                                                                    { columName: 'Code', bindingValue: 'display', },
                                                                                    { columName: 'Description', bindingValue: 'Description', },
                                                                                ]}
                                                                                ApiLink={API_URL + "/ModifierInstantSearch"}
                                                                                method='post'
                                                                                postBody={modifierBody}
                                                                                disabled={true}
                                                                                // placeholder={""}
                                                                                sup_btn='sup_btn-Inp'
                                                                                sup_inp='superSearchVisitInp'
                                                                                placeholder={false}
                                                                                // inputError={!isNull(serviceLineValidation[index]?.ModifierCode1Val) || !isNull(serviceLineValidation[index]?.ModifierCode1UNI) ? true : false}
                                                                                isItemSelected={!isNull(data.ModifierCode1) ? true : false}
                                                                            // handleAddNewCode={(searchValue, name) => handleAddNewModifier(searchValue, name, index)}
                                                                            // handleonFocus={handleOnFocusServiceline}
                                                                            // handleOnblur={(value, name) => handleOnBlurForHoverModifers(value, name, index)}
                                                                            />
                                                                            {/* {data?.Modifier1Description ? <p className="tool_tip" 
                                                            style={divStyle}
                                                            ><span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={data?.Modifier1Description}>{data?.Modifier1Description} </span></p> : null} */}
                                                                        </div>
                                                                        <div
                                                                        //  className={isFocused ? "" : 'za-denied-status'} onMouseEnter={handleMouseEnter}
                                                                        >
                                                                            <SuperICDandCPTSearch
                                                                                type='server'
                                                                                customData={RecentModifiers}
                                                                                id='Modifier Code'
                                                                                name='ModifierCode2'
                                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                                                                getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode2', '', 'CPT')}
                                                                                searchValue={data.ModifierCode2}
                                                                                searchBy={['display', 'Description']}
                                                                                tableData={[
                                                                                    { columName: 'Code', bindingValue: 'display', },
                                                                                    { columName: 'Description', bindingValue: 'Description', },
                                                                                ]}
                                                                                ApiLink={API_URL + "/ModifierInstantSearch"}
                                                                                method='post'
                                                                                postBody={modifierBody}
                                                                                disabled={true}
                                                                                placeholder={false}
                                                                                sup_btn='sup_btn-Inp'
                                                                                sup_inp='superSearchVisitInp'
                                                                                // inputError={!isNull(serviceLineValidation[index]?.ModifierCode1Val) || !isNull(serviceLineValidation[index]?.ModifierCode1UNI) ? true : false}
                                                                                isItemSelected={!isNull(data.ModifierCode2) ? true : false}
                                                                            // handleAddNewCode={(searchValue, name) => handleAddNewModifier(searchValue, name, index)}
                                                                            // handleonFocus={handleOnFocusServiceline}
                                                                            // handleOnblur={(value, name) => handleOnBlurForHoverModifers(value, name, index)}
                                                                            />
                                                                            {/* {data?.Modifier2Description ? <p className="tool_tip" style={divStyle}><span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={data?.Modifier2Description}> {data?.Modifier2Description}</span></p> : null} */}
                                                                        </div>
                                                                        <div
                                                                        // className={isFocused ? "" : 'za-denied-status'} onMouseEnter={handleMouseEnter}
                                                                        >
                                                                            <SuperICDandCPTSearch
                                                                                type='server'
                                                                                customData={RecentModifiers}
                                                                                id='Modifier Code'
                                                                                name='ModifierCode3'
                                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                                                                getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode3', '', 'CPT')}
                                                                                searchValue={data.ModifierCode3}
                                                                                searchBy={['display', 'Description']}
                                                                                tableData={[
                                                                                    { columName: 'Code', bindingValue: 'display', },
                                                                                    { columName: 'Description', bindingValue: 'Description', },
                                                                                ]}
                                                                                ApiLink={API_URL + "/ModifierInstantSearch"}
                                                                                method='post'
                                                                                postBody={modifierBody}
                                                                                disabled={true}
                                                                                placeholder={false}
                                                                                sup_btn='sup_btn-Inp'
                                                                                sup_inp='superSearchVisitInp'
                                                                                // inputError={!isNull(serviceLineValidation[index]?.ModifierCode1Val) || !isNull(serviceLineValidation[index]?.ModifierCode1UNI) ? true : false}
                                                                                isItemSelected={!isNull(data.ModifierCode3) ? true : false}
                                                                            // handleAddNewCode={(searchValue, name) => handleAddNewModifier(searchValue, name, index)}
                                                                            // handleonFocus={handleOnFocusServiceline}
                                                                            // handleOnblur={(value, name) => handleOnBlurForHoverModifers(value, name, index)}
                                                                            />
                                                                            {/* {data?.Modifier3Description ? <p className="tool_tip" style={divStyle}><span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={data?.Modifier3Description}>{data?.Modifier3Description} </span></p> : null} */}
                                                                        </div>
                                                                        <div
                                                                        // className={isFocused ? "" : 'za-denied-status'} onMouseEnter={handleMouseEnter}
                                                                        >
                                                                            <SuperICDandCPTSearch
                                                                                type='server'
                                                                                customData={RecentModifiers}
                                                                                id='Modifier Code'
                                                                                name='ModifierCode4'
                                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                                                                getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode4', '', 'CPT')}
                                                                                searchValue={data.ModifierCode4}
                                                                                searchBy={['display', 'Description']}
                                                                                tableData={[
                                                                                    { columName: 'Code', bindingValue: 'display', },
                                                                                    { columName: 'Description', bindingValue: 'Description', },
                                                                                ]}
                                                                                ApiLink={API_URL + "/ModifierInstantSearch"}
                                                                                method='post'
                                                                                postBody={modifierBody}
                                                                                disabled={true}
                                                                                placeholder={false}
                                                                                sup_btn='sup_btn-Inp'
                                                                                sup_inp='superSearchVisitInp'
                                                                                // inputError={!isNull(serviceLineValidation[index]?.ModifierCode1Val) || !isNull(serviceLineValidation[index]?.ModifierCode1UNI) ? true : false}
                                                                                isItemSelected={!isNull(data.ModifierCode4) ? true : false}
                                                                            // handleAddNewCode={(searchValue, name) => handleAddNewModifier(searchValue, name, index)}
                                                                            // handleonFocus={handleOnFocusServiceline}
                                                                            // handleOnblur={(value, name) => handleOnBlurForHoverModifers(value, name, index)}
                                                                            />
                                                                            {/* {data?.Modifier4Description ? <p className="tool_tip" style={divStyle}><span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={data?.Modifier4Description}> {data?.Modifier4Description}</span></p> : null} */}
                                                                        </div>
                                                                        {/* {isReadOnly ? null : <i class="icon-search" onClick={() => handleOpenModifiers(index)}></i>} */}
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className='hk-table-flex'>
                                                                        <input
                                                                            variant="outlined"
                                                                            type="text"
                                                                            className={!isNull(serviceLineValidation[index]?.Pointer1UNI) ||
                                                                                !isNull(serviceLineValidation[index]?.Pointer1Val) ||
                                                                                !isNull(serviceLineValidation[index]?.Pointer1ICD) ? 'form-control input_error' : 'form-control'}
                                                                            name="Pointer1"
                                                                            id="Pointer1"
                                                                            maxLength={2}
                                                                            value={data.Pointer1}
                                                                            // onChange={(e) => handleServiceLineChange(data.RowID, e)}
                                                                            onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer1')}
                                                                            onBlur={(e) => handleOnblurServiceline(e, index)}
                                                                            onKeyPress={handleNumericCheck}
                                                                        // readOnly={isReadOnly}
                                                                        />
                                                                        <input
                                                                            variant="outlined"
                                                                            type="text"
                                                                            className={!isNull(serviceLineValidation[index]?.Pointer1UNI) ||
                                                                                !isNull(serviceLineValidation[index]?.Pointer1Val) ||
                                                                                !isNull(serviceLineValidation[index]?.Pointer2ICD) ? 'form-control input_error' : 'form-control'}
                                                                            // className="form-control"
                                                                            name="Pointer2"
                                                                            id="Pointer2"
                                                                            maxLength={2}
                                                                            value={data.Pointer2}
                                                                            // onChange={(e) => handleServiceLineChange(data.RowID, e)}
                                                                            onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer2')}
                                                                            onBlur={(e) => handleOnblurServiceline(e, index)}
                                                                            onKeyPress={handleNumericCheck}
                                                                        // readOnly={isReadOnly}
                                                                        />
                                                                        <input
                                                                            variant="outlined"
                                                                            type="text"
                                                                            className={
                                                                                !isNull(serviceLineValidation[index]?.Pointer1UNI) ||
                                                                                    !isNull(serviceLineValidation[index]?.Pointer1Val) ||
                                                                                    !isNull(serviceLineValidation[index]?.Pointer3ICD) ? 'form-control input_error' : 'form-control'}
                                                                            name="Pointer3"
                                                                            id="Pointer3"
                                                                            maxLength={2}
                                                                            value={data.Pointer3}
                                                                            // onChange={(e) => handleServiceLineChange(data.RowID, e)}
                                                                            onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer3')}
                                                                            onBlur={(e) => handleOnblurServiceline(e, index)}
                                                                            onKeyPress={handleNumericCheck}
                                                                        // readOnly={isReadOnly}
                                                                        />
                                                                        <input
                                                                            variant="outlined"
                                                                            type="text"
                                                                            className={
                                                                                !isNull(serviceLineValidation[index]?.Pointer1UNI) ||
                                                                                    !isNull(serviceLineValidation[index]?.Pointer1Val) ||
                                                                                    !isNull(serviceLineValidation[index]?.Pointer4ICD) ? 'form-control input_error' : 'form-control'}
                                                                            name="Pointer4"
                                                                            id="Pointer4"
                                                                            maxLength={2}
                                                                            value={data.Pointer4}
                                                                            // onChange={(e) => handleServiceLineChange(data.RowID, e)}
                                                                            onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer4')}
                                                                            onBlur={(e) => handleOnblurServiceline(e, index)}
                                                                            onKeyPress={handleNumericCheck}
                                                                        // readOnly={isReadOnly}
                                                                        />
                                                                    </div>
                                                                </td>
                                                                <td >
                                                                    <input
                                                                        type="text"
                                                                        className={`form-control units unit ${!isNull(serviceLineValidation[index]?.UnitsVal) ? 'error' : ''}`}
                                                                        name="Units"
                                                                        id="Units"
                                                                        variant="outlined"
                                                                        value={data.Units}
                                                                        // onChange={(e) => handleServiceLineChange(data.RowID, e)}
                                                                        onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Units')}
                                                                    // readOnly={isReadOnly ? true : false}
                                                                    />

                                                                </td>
                                                                <td className='text-center'>
                                                                    <span onClick={() => handleDeleteRow(index)}><i class="fs-14 icon-delete" style={{ color: 'red' }}></i></span>
                                                                </td>
                                                            </tr>
                                                            {/* <tr>
                                                <td></td>
                                                {AmountValidationExist ?
                                                <td colSpan={18} className='message error_message'>
                                                    <span className='xsm_heading fs-12 fst-italic '>{
                                                    // errorText
                                                    }</span>
                                                </td> : <></>
                                                }
                                            </tr> */}
                                                            {CheckValidation === true ? null :
                                                                <tr>
                                                                    <td colSpan={12} className='message error_message'>
                                                                        {!isNull(serviceLineValidation[index]?.DOSFromVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.DOSFromVal} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.DOSToVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.DOSToVal} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.CPTCodeVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.CPTCodeVal} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.ModifierCode1Val) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.ModifierCode1Val} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.ModifierCode1UNI) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.ModifierCode1UNI} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.Pointer1Val) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer1Val} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.Pointer1UNI) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer1UNI} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.Pointer1ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer1ICD} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.Pointer2ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer2ICD} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.Pointer3ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer3ICD} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.Pointer4ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer4ICD} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.POSVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.POSVal} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.UnitsVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.UnitsVal} </p> : null}
                                                                    </td>
                                                                </tr>
                                                            }
                                                        </>
                                                    )
                                                }
                                            })}
                                        </>
                                    </tbody> :
                                    <tbody>
                                        {mainServiceLineModal?.map((data, index) => {
                                            // console.log("dataServiceLineInfo",data);
                                            let processedAsDD = [];
                                            let displayProcedureCode = data?.ProcedureCode;
                                            // let amountVals = amountValidationModal?.[data?.ServiceLineID];
                                            // let amountVals = {}?.[data?.ServiceLineID];
                                            // const AmountValidationExist = amountVals ? Object.values(amountVals).some(value => value) : null;
                                            // let errorText = handleValidationErrorText(amountVals);
                                            // let datas = {
                                            // name: 'Claims',
                                            // data: {
                                            //     id: data?.ClaimID,
                                            //     name: item?.PatientInfo?.NM1_03_NameFirst,
                                            //     ClaimRecord: claimRecord,
                                            // }
                                            // };
                                            // data.TransferToSecondary === null && handleTransferToSecondary(VISIT_PAYMENT_index,index,data);
                                            // let VISIT_PAYMENT_index = '';
                                            if (data?.Deleted !== "true") {
                                                return (
                                                    <>
                                                        <tr key={data.ServiceLineID}>
                                                            <td className='position-relative'>
                                                                <div className='input select-bg-img'>
                                                                    {displayProcedureCode}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='hk-table-flex' >
                                                                    {[data.ModifierCode1, data.ModifierCode2, data.ModifierCode3, data.ModifierCode4]
                                                                        .filter(Boolean)
                                                                        .join(', ')}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='hk-table-flex'>
                                                                    {[data.Pointer1, data.Pointer2, data.Pointer3, data.Pointer4]
                                                                        .filter(Boolean)
                                                                        .join(', ')}
                                                                </div>
                                                            </td>
                                                            <td>{data.Units}</td>
                                                        </tr>
                                                    </>
                                                )
                                            }
                                        })}
                                    </tbody>}
                            </table>
                        </div>

                    </div>


                    {/* {searchParam?.EncounterStatus !== "Signed" &&
                     ( */}

                    {/* <div className="p-2 PateintBalance">
                        <div className={`d-flex align-items-center gap-6 ${isSignEditAllowed ? '' : 'disable'}`}>
                            <div className="custom_check_box d-flex">
                                <input
                                    type="checkbox"
                                    className="form-check-input mt-0"
                                    checked={isSign}
                                    onChange={() => setIsSign(true)}
                                    disabled={!isSignEditAllowed}
                                />
                            </div>
                            <p className='text font-m'>I declare that these services are medically necessary and appropriate to the patient's problems and needs.</p>
                        </div>
                    </div> */}

                    {/* )} */}
                </div>}
            <PrintOutSelectDataModal printoutSelectDataModal={printoutSelectDataModal} setPrintoutSelectDataModal={setPrintoutSelectDataModal} setPrintoutModal={setPrintoutModal} selectedItems={selectedItems} setSelectedItems={setSelectedItems} showAddressTypeLocation={showAddressTypeLocation} setShowAddressTypeLocation={setShowAddressTypeLocation} id={encounterID} insertPosition={insertPosition} customTemplateData={props?.customTemplateData} />
            <Modal show={printoutModal} onHide={printoutModal} backdrop="static" keyboard={false} centered dialogClassName="ar_encounter_print_modal ar_encounter_main_screen ar_encounter_preview_sceen p-0 hk-modal-v1 table-default-design bg-transparent" >
                {isLoadingPdf && <Loader />}
                <Modal.Body className='hover-scrollbar'>
                    <div className="d-flex align-items-center justify-content-center gap-2 pt-15 ar_print-header pb-2">
                        <span class="icon-Group-1000002858 fs-20" onClick={() => captureDataAndGeneratePDF(componentRef, `${initialData?.Data?.PatientName || 'PhysicalNote'} - ${searchParam?.EncounterDate}.pdf`, 'highRes')}>
                            <span class="path1"></span><span class="path2"></span>
                        </span>
                        <i className="icon-Icon-metro-cross fs-20" onClick={() => setPrintoutModal(false)}></i>
                    </div>
                    {/* <div style={{ position: 'absolute', left: '-9999px' }}> */}
                    <div ref={componentRef}>
                        <div className={`px-10 pb-15 pt-2 ar_native_pdf_design encounter-notes-design ${selectedItems?.["uiDesign"] ? 'Black-in-White-Design' : ''}`}>
                            <SelectedPreviewDataV2 showAddressTypeLocation={showAddressTypeLocation} selectedItems={selectedItems} data={initialData} searchParam={searchParam} searchValue={searchValue} Data={{
                                ...(subjectiveData || {}),
                                ...(objectiveData || {}),
                                ...(observationsData || {}),
                                ...(assessmentData || {}),
                                ...(planData || {}),
                                ...(additionalInfoData || {}),
                                // "vitalData": vitalData,
                                "mainServiceLineModal": mainServiceLineModal,
                                "ObjectiveNotes": objectiveData?.ObjectiveNotes,
                                "AssesmentNotes": assessmentData?.AssesmentNotes,
                                "PlanNotes": planData?.PlanNotes,
                                'CustomTemplateData': props?.customTemplateData,
                                "AdditionalInfoNotes": additionalInfoData?.AdditionalInfoNotes,
                                "EncounterCoSignData": initialData?.EncounterCoSign || [],
                            }} />
                        </div>
                    </div>
                    {/* </div> */}
                </Modal.Body>
            </Modal>

        </>
    )
})

export default PhysicalNote

